const ar = {
    // ==================== COMMON ====================
    common: {
        appName: 'Email Lion',
        loading: 'جارٍ التحميل...',
        error: 'خطأ',
        success: 'نجاح',
        save: 'حفظ',
        cancel: 'إلغاء',
        close: 'إغلاق',
        delete: 'حذف',
        edit: 'تعديل',
        create: 'إنشاء',
        update: 'تحديث',
        back: 'رجوع',
        next: 'التالي',
        previous: 'السابق',
        search: 'بحث',
        refresh: 'تحديث',
        send: 'إرسال',
        confirm: 'تأكيد',
        yes: 'نعم',
        no: 'لا',
        or: 'أو',
        all: 'الكل',
        none: 'بدون',
        status: 'الحالة',
        name: 'الاسم',
        actions: 'إجراءات',
        date: 'التاريخ',
        time: 'الوقت',
        today: 'اليوم',
        print: 'طباعة',
        export: 'تصدير',
        import: 'استيراد',
        test: 'اختبار',
        enabled: 'مفعّل',
        disabled: 'معطّل',
        default: 'افتراضي',
        optional: 'اختياري',
        required: 'مطلوب',
        noData: 'لا توجد بيانات للعرض',
        errorLoadingData: 'خطأ في تحميل البيانات',
        errorSaving: 'خطأ في الحفظ',
        errorDeleting: 'خطأ في الحذف',
        voiceBlocked: 'حظر المتصفح الميكروفون. اسمح بالوصول من إعدادات الموقع ثم حاول مرة أخرى.',
        voiceNeedReload: 'الميكروفون مسموح به في الإعدادات، لكن الصفحة لم تتحدث بعد. أعد تحميل الصفحة ثم اضغط على الميكروفون مرة أخرى.',
        voiceNoDevice: 'لم يتم العثور على ميكروفون. تحقق من توصيل الجهاز والسماح به في النظام.',
        voiceBusy: 'الميكروفون قيد الاستخدام في تطبيق آخر. أغلق Zoom أو Teams أو Meet ثم حاول مرة أخرى.',
        voiceSpeechFailed: 'فشل التعرف على الكلام. حاول مرة أخرى أو أعد تحميل الصفحة.',
        voiceNotSupported: 'الإدخال الصوتي غير مدعوم في هذا المتصفح. استخدم Chrome.',
        voiceInputTooltip: 'إدخال صوتي',
        voiceStop: 'إيقاف التسجيل',
        voiceListening: 'أستمع... تحدث الآن',
        upgradeRequired: 'لاستخدام هذه الوحدة، يرجى ترقية باقتك أو التواصل مع مسؤول النظام.',
        viewPlans: 'عرض الباقات والترقية',
        files: 'ملفات',
        from: 'من',
        subject: 'الموضوع',
        noSubject: '(بدون موضوع)',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        emailAccount: 'حساب البريد الإلكتروني',
        runNow: 'تشغيل الآن',
        description: 'الوصف',
        errorLoadingAccounts: 'خطأ في تحميل الحسابات',
        errorStatusChange: 'خطأ في تغيير الحالة',
        errorLogin: 'خطأ في تسجيل الدخول',
        use: 'استخدام',
        recommended: 'موصى به',
        free: 'مجاني',
    },

    // ==================== LOGIN ====================
    login: {
        subtitle: 'نظام بريد إلكتروني للمؤسسات',
        loginTab: 'تسجيل الدخول',
        registerTab: 'تسجيل مجاني',
        emailLabel: 'البريد الإلكتروني',
        passwordLabel: 'كلمة المرور',
        twoFactorLabel: 'رمز المصادقة الثنائية (2FA)',
        twoFactorHelper: 'أدخل الرمز من تطبيق المصادقة الخاص بك',
        verifyAndLogin: 'تحقق وسجّل الدخول',
        loginButton: 'تسجيل الدخول',
        forgotPassword: 'نسيت كلمة المرور',
        fullName: 'الاسم الكامل *',
        emailRequired: 'البريد الإلكتروني *',
        passwordRequired: 'كلمة المرور *',
        minChars: '6 أحرف على الأقل',
        confirmPassword: 'تأكيد كلمة المرور *',
        passwordsMismatch: 'كلمتا المرور غير متطابقتين',
        companyName: 'اسم الشركة (اختياري)',
        phone: 'الهاتف *',
        phoneHelper: 'رقم هاتف صالح (9 أرقام على الأقل)',
        registering: 'جارٍ التسجيل...',
        registerFree: 'سجّل مجانًا',
        freePlan: 'باقة مجانية · بدون بطاقة ائتمان · صندوق بريد واحد',
        googleLogin: 'تسجيل الدخول عبر Google',
        googleRegister: 'التسجيل عبر Google',
        termsAgree: 'بالتسجيل، أوافق على',
        termsOfService: 'شروط الاستخدام',
        privacyPolicy: 'سياسة الخصوصية',
        backToSite: 'العودة إلى الصفحة الرئيسية',
        resetPassword: 'إعادة تعيين كلمة المرور',
        stepEnterEmail: 'إدخال البريد الإلكتروني',
        stepVerifyCode: 'التحقق من الرمز',
        stepNewPassword: 'كلمة مرور جديدة',
        resetEmailPrompt: 'أدخل عنوان بريدك الإلكتروني وسنرسل لك رمزًا لإعادة تعيين كلمة المرور.',
        emailAddress: 'عنوان البريد الإلكتروني',
        codeSentTo: 'تم إرسال رمز التحقق إلى ',
        enterCode: '. أدخل الرمز:',
        verificationCode: 'رمز التحقق (6 أرقام)',
        newPasswordPrompt: 'أدخل كلمة المرور الجديدة (6 أحرف على الأقل):',
        newPassword: 'كلمة مرور جديدة',
        confirmPasswordLabel: 'تأكيد كلمة المرور',
        sendCode: 'إرسال الرمز',
        verifyCode: 'تحقق من الرمز',
        resetPasswordBtn: 'إعادة تعيين كلمة المرور',
        sessionExpired: 'انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.',
        errorFullName: 'يرجى إدخال اسمك الكامل',
        errorValidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح (وليس مؤقتاً)',
        errorPhone: 'يرجى إدخال رقم هاتف صالح (9 أرقام على الأقل)',
        errorMinPassword: 'يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل',
        errorPasswordMatch: 'كلمتا المرور غير متطابقتين',
        registerSuccess: 'اكتمل التسجيل! يمكنك الآن تسجيل الدخول.',
        errorRegister: 'خطأ في التسجيل',
        errorGoogleAuth: 'خطأ في المصادقة عبر Google',
        errorGoogleFailed: 'فشلت المصادقة عبر Google، حاول مرة أخرى.',
        errorGoogleUnavailable: 'خدمة Google غير متاحة حاليًا',
        errorEnterEmail: 'يرجى إدخال عنوان بريدك الإلكتروني',
        errorSendCode: 'خطأ في إرسال الرمز',
        errorEnterCode: 'يرجى إدخال رمز مكوّن من 6 أرقام',
        errorResetPassword: 'خطأ في إعادة تعيين كلمة المرور',
        and: 'وعلى',
        rememberMe30: 'تذكرني لمدة 30 يومًا',
        keepLoggedInForever: 'إبقائي مسجّل الدخول على هذا الجهاز',
        keepLoggedInHint: 'موصى به للهاتف المحمول الشخصي. لا تستخدمه على جهاز كمبيوتر مشترك.',
    },

    // ==================== LAYOUT ====================
    layout: {
        dashboard: 'لوحة التحكم',
        webmail: 'بريد الويب',
        calendar: 'التقويم',
        orgManagement: 'المؤسسة',
        organizations: 'المؤسسات',
        domains: 'النطاقات',
        mailboxes: 'صناديق البريد',
        users: 'المستخدمون',
        operations: 'الفوترة والعمليات',
        plans: 'الباقات والتخزين',
        proposals: 'عروض الأسعار',
        billing: 'الفوترة',
        branding: 'العلامة التجارية',
        monitoring: 'الأمان',
        reports: 'التقارير والسجلات',
        systemHealth: 'صحة النظام',
        auditLog: 'سجل التدقيق',
        tools: 'الأدوات',
        aiAgent: 'وكيل AI الشخصي',
        automations: 'أتمتة AI',
        filing: 'أرشفة المستندات',
        smartCleanup: 'التنظيف الذكي AI',
        autoReplyLog: 'سجل ردود AI',
        migration: 'ترحيل البريد الإلكتروني',
        marketingCockpit: 'التسويق',
        salesEngine: 'محرك المبيعات',
        integrations: 'التكاملات',
        settings: 'الإعدادات',
        viewingAsUser: 'العرض كمستخدم',
        backToAdmin: 'العودة إلى الإدارة',
        viewingAsUserClick: 'العرض كمستخدم – انقر للعودة',
        website: 'الموقع الإلكتروني',
        backToWebsite: 'العودة إلى الموقع',
        help: 'مساعدة',
        helpCenter: 'مركز المساعدة',
        helpTooltip: 'المساعدة والشروحات',
        darkMode: 'الوضع الداكن',
        lightMode: 'الوضع الفاتح',
        expandMenu: 'توسيع القائمة',
        collapseMenu: 'طي القائمة',
        logout: 'تسجيل الخروج',
        language: 'اللغة',
        roles: {
            super_admin: 'المسؤول الأعلى',
            multi_org_admin: 'مسؤول عدة مؤسسات',
            org_admin: 'مسؤول المؤسسة',
            user: 'مستخدم',
        },
    },

    // ==================== SMART CLEANUP ====================
    cleanup: {
        title: 'وكيل التنظيف الذكي AI',
        subtitle: 'فحص ذكي لصندوق بريدك: التعرف على النشرات البريدية والرسائل المزعجة والرسائل القديمة والملفات الكبيرة والمكررة. إلغاء الاشتراك، الحذف، النقل إلى مجلدات والتنظيف بذكاء.',
        startScan: 'بدء الفحص',
        scanning: 'جارٍ الفحص...',
        errorScan: 'خطأ في بدء الفحص',
        errorScanResult: 'خطأ في الفحص',
        noAccountTitle: 'قم بربط حساب بريد إلكتروني لاستخدام وكيل التنظيف',
        noAccountSubtitle: 'انتقل إلى بريد الويب واربط صندوق بريد أولًا',
        readyTitle: 'هل أنت مستعد لتنظيف صندوق بريدك؟',
        readySubtitle: 'سيقوم الوكيل الذكي بفحص صندوق الوارد، والعثور على النشرات البريدية والرسائل المزعجة والرسائل القديمة والكبيرة، واقتراح إجراءات تنظيف ذكية. اختر ما تريد حذفه أو نقله أو أرشفته.',
        startSmartScan: 'بدء الفحص الذكي',
        newsletters: 'النشرات البريدية',
        newslettersDesc: 'رسائل تتضمن خيار إلغاء الاشتراك',
        spam: 'الرسائل المزعجة',
        spamDesc: 'رسائل يُشتبه بأنها مزعجة',
        old: 'قديمة (أكثر من 6 أشهر)',
        oldDesc: 'رسائل أقدم من 6 أشهر',
        large: 'كبيرة (أكثر من 5MB)',
        largeDesc: 'رسائل تحتوي على مرفقات كبيرة',
        notifications: 'الإشعارات',
        notificationsDesc: 'إشعارات تلقائية',
        duplicates: 'المكررات',
        duplicatesDesc: 'رسائل بمواضيع متطابقة',
        deselectAll: 'إلغاء تحديد الكل',
        selectAll: 'تحديد الكل',
        selected: 'محدد',
        deleteSelected: 'حذف المحدد',
        deleteBtn: 'حذف',
        moveToFolder: 'نقل إلى مجلد',
        moveBtn: 'نقل',
        archive: 'أرشيف',
        markSpam: 'وضع علامة كرسالة مزعجة',
        spamBtn: 'مزعج',
        markRead: 'وضع علامة كمقروء',
        readBtn: 'مقروء',
        page: 'صفحة',
        noneFound: 'لم يتم العثور على رسائل في هذه الفئة',
        unsubscribe: 'إلغاء الاشتراك',
        unsubscribeTooltip: 'إلغاء الاشتراك من القائمة البريدية',
        deleteConfirmTitle: 'تأكيد الحذف',
        deleteConfirmMsg: 'سيؤدي هذا إلى حذف {count} رسالة. لا يمكن استعادة الرسائل المحذوفة.',
        deleteCount: 'حذف {count} رسالة',
        moveTitle: 'نقل إلى مجلد',
        movePrompt: 'اختر مجلدًا مستهدفًا لنقل {count} رسالة:',
        folderName: 'اسم المجلد',
        folderPlaceholder: 'مثلًا: نشرات بريدية، عملاء، أرشيف...',
        folderHelper: 'أدخل اسم مجلد موجود أو جديد',
        executedResult: 'تم: {success} نجحت، {failed} فشلت',
        errorExecute: 'خطأ في تنفيذ الإجراء',
        rescan: 'إعادة الفحص',
        loadingCached: 'جارٍ تحميل نتائج الفحص السابق...',
        cachedLabel: 'محفوظ مؤقتًا',
        lastScanAt: 'آخر فحص: {date}',
        insightsSummary: 'تم فحص {total} رسالة · تم العثور على {items} عنصرًا للمعالجة',
        organizeBtn: 'تنظيم في مجلدات',
        organizeTooltip: 'نقل النشرات البريدية والإشعارات والرسائل المزعجة تلقائيًا إلى مجلدات منظمة',
        organizeTitle: 'تنظيم تلقائي في مجلدات',
        organizeDesc: 'سيقوم الوكيل الذكي بنقل الرسائل تلقائيًا إلى مجلدات منظمة بناءً على تصنيف الفحص:',
        organizeInfo: 'المجلدات غير الموجودة سيتم إنشاؤها تلقائيًا. الرسائل المنقولة ستغادر صندوق الوارد INBOX.',
        organizeComplete: 'اكتمل التنظيم بنجاح!',
        organizeSuccess: 'تم تنظيم INBOX في مجلدات بنجاح',
        organizing: 'جارٍ التنظيم...',
        organizeNow: 'نظّم الآن',
        errorOrganize: 'خطأ في التنظيم في مجلدات',
        movedToFolder: 'تم النقل إلى المجلد',
        failedItems: 'فشلت',
        foldersCreated: 'مجلدات تم إنشاؤها',
    },

    // ==================== CALENDAR ====================
    calendar: {
        days: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        daysShort: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
        months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
        newEvent: 'حدث جديد',
        editEvent: 'تعديل الحدث',
        title: 'العنوان',
        descriptionLabel: 'الوصف',
        location: 'الموقع',
        start: 'البداية',
        end: 'النهاية',
        allDay: 'طوال اليوم',
        color: 'اللون:',
        month: 'شهر',
        week: 'أسبوع',
        day: 'يوم',
        addEvent: 'إضافة حدث',
        eventCreated: 'تم إنشاء الحدث بنجاح',
        eventUpdated: 'تم تحديث الحدث',
        eventDeleted: 'تم حذف الحدث',
        eventMoved: 'تم نقل الحدث',
        undo: 'تراجع',
        redo: 'إعادة',
        undoDone: 'تم التراجع',
        redoDone: 'تمت الإعادة',
        undoFailed: 'تعذر التراجع',
        redoFailed: 'تعذرت الإعادة',
        deleteEvent: 'هل تريد حذف هذا الحدث؟',
        errorSaving: 'خطأ في الحفظ',
        errorDeleting: 'خطأ في الحذف',
        requiredFields: 'العنوان وتاريخ البداية وتاريخ النهاية حقول مطلوبة',
        noReminder: 'بدون تذكير',
        min5: 'قبل 5 دقائق',
        min10: 'قبل 10 دقائق',
        min15: 'قبل 15 دقيقة',
        min30: 'قبل 30 دقيقة',
        hour1: 'قبل ساعة واحدة',
        hour2: 'قبل ساعتين',
        day1: 'قبل يوم واحد',
        once: 'مرة واحدة',
        daily: 'يومي',
        weekly: 'أسبوعي',
        monthly: 'شهري',
        yearly: 'سنوي',
        printCalendar: 'طباعة التقويم',
        printPrompt: 'اختر طريقة عرض للطباعة:',
        dailyView: 'يومي',
        weeklyView: 'أسبوعي',
        monthlyView: 'شهري',
        yearlyView: 'سنوي',
        yearLabel: 'سنة',
        weekLabel: 'أسبوع',
        printWindowBlocked: 'تم حظر نافذة الطباعة – اسمح بالنوافذ المنبثقة',
        syncCalendar: 'مزامنة التقويم',
        syncTooltip: 'مزامنة iCal',
        subscriptionUrl: 'رابط الاشتراك',
        subscriptionHelper: 'انسخ الرابط وأضفه كتقويم خارجي',
        copy: 'نسخ',
        regenerate: 'جديد',
        syncUrlCopied: 'تم نسخ رابط المزامنة',
        syncUrlRegenerated: 'تم إنشاء رابط مزامنة جديد',
        exportIcs: 'تصدير ICS',
        importIcs: 'استيراد ICS',
        exportDone: 'تم تنزيل الملف',
        importDone: 'تم استيراد {count} حدثًا',
        errorExport: 'خطأ في التصدير',
        errorImport: 'خطأ في الاستيراد',
        exportImport: 'تصدير / استيراد',
        externalSyncTitle: 'مزامنة ثنائية الاتجاه تلقائية',
        externalSyncHelper: 'اربط Google Calendar أو Outlook — تظهر الأحداث هنا وتتحدث تلقائياً في الاتجاهين.',
        connectGoogle: 'ربط Google Calendar',
        connectOutlook: 'ربط Outlook',
        disconnectGoogle: 'قطع Google',
        disconnectOutlook: 'قطع Outlook',
        syncNow: 'زامن الآن',
        syncDone: 'اكتملت المزامنة',
        syncFailed: 'فشلت المزامنة',
        connectedAs: 'متصل باسم {email}',
        lastSync: 'آخر مزامنة: {time}',
        sourceGoogle: 'Google',
        sourceOutlook: 'Outlook',
        sourceLocal: 'محلي',
        notConfiguredGoogle: 'Google Calendar غير مُعد على الخادم',
        notConfiguredOutlook: 'Outlook Calendar غير مُعد على الخادم',
        calendarHint: 'Email Lion - التقويم',
        aiAgent: 'وكيل التقويم AI',
        aiAgentTooltip: 'وكيل AI ذكي',
        aiHello: 'مرحبًا! أنا وكيل التقويم الخاص بك',
        aiSubtitle: 'أخبرني بلغة عادية بما تريد جدولته',
        aiPlaceholder: 'أخبرني بما تريد جدولته وسأتولى الأمر',
        aiInputPlaceholder: 'مثلًا: "اجتماع فريق يوم الخميس الساعة 3:00 مساءً"',
        aiDaySummary: 'ملخص اليوم',
        aiThinking: 'جارٍ التفكير...',
        voiceInputTooltip: 'إدخال صوتي',
        voiceStop: 'إيقاف التسجيل',
        voiceListening: 'أستمع... تحدث الآن',
        voiceNotSupported: 'الإدخال الصوتي غير مدعوم في هذا المتصفح',
        aiErrorSummary: 'خطأ في الحصول على ملخص اليوم',
        requestProcessed: 'تمت معالجة الطلب بنجاح.',
        eventsCreated: 'تم إنشاء {count} حدثًا:',
        more: 'المزيد',
        reminder: 'تذكير',
        reminderSnack: '🔔 تذكير: {title} في {time}',
        reminderBody: 'في {time}',
        aiCreatedEvents: '📅 تم إنشاء {count} حدثًا:',
        aiNoResponse: 'لم يتم استلام أي رد.',
        aiSummaryPrefix: '📊 ملخص {date}:',
        aiNoInfo: 'لا توجد معلومات',
        aiExampleChip: 'اجتماع غدًا الساعة 10',
        aiExampleChipPrompt: 'حدّد لي اجتماعًا غدًا الساعة العاشرة صباحًا في تل أبيب مع المورد',
        aiExample1: 'حدّد لي اجتماعًا غدًا الساعة العاشرة صباحًا في تل أبيب',
        aiExample2: 'أنشئ 3 تذكيرات أسبوعية: مراجعة، فريق، وملخص',
        aiExample3: 'اجتماع إدارة عاجل اليوم الساعة 4:00 مساءً + تذكير',
        syncCopyTooltip: 'نسخ',
        syncRegenerateTooltip: 'إعادة إنشاء',
        syncGoogleInstructions: 'الإعدادات - إضافة تقويم - من رابط URL',
        syncAppleInstructions: 'ملف - اشتراك جديد',
        syncOutlookInstructions: 'إضافة تقويم - الاشتراك من الويب',
        icalGoogleWarning: 'Google Calendar متصل بالفعل بمزامنة ثنائية الاتجاه. لا تضف رابط iCal إلى Google — فهذا يكرر كل حدث. ألغِ تحديد "Email Lion Calendar" في الشريط الجانبي الأيسر. رابط iCal مخصص لـ Apple Calendar أو تقويم آخر فقط.',
        dedupeButton: 'إزالة التكرارات',
        dedupeConfirm: 'حذف الصفوف المكررة في Email Lion (نفس الحدث مرتين)؟ لن تُحذف الأحداث في Google نفسه — إذا ظهرت التكرارات هناك، ألغِ تحديد "Email Lion Calendar" في الشريط الجانبي.',
        dedupeDone: 'تمت إزالة {count} تكرارات',
        dedupeNone: 'لم يتم العثور على تكرارات في Email Lion',
        aiClearChat: 'مسح المحادثة',
        aiClearConfirm: 'هل تريد مسح سجل المحادثة مع الوكيل؟',
    },

    // ==================== AUTOMATIONS ====================
    automations: {
        title: 'أتمتة البريد الإلكتروني بالذكاء الاصطناعي',
        subtitle: 'أنشئ قواعد تلقائية لمعالجة الرسائل باستخدام AI – استخراج البيانات، الملخصات، الحسابات والمزيد',
        moduleTitle: 'أتمتة البريد الإلكتروني بالذكاء الاصطناعي',
        moduleDesc: 'اعمل بذكاء أكبر – أنشئ قواعد تعالج الرسائل والمرفقات تلقائيًا باستخدام AI. استخراج البيانات من ملفات PDF، تلخيص المستندات، حساب جداول البيانات والمزيد.',
        moduleFeatures: ['معالجة PDF/Excel/CSV', 'ملخصات المستندات', 'استخراج البيانات', 'إخراج بريد إلكتروني/Webhook', '3 محركات AI'],
        newAutomation: 'أتمتة جديدة',
        editAutomation: 'تعديل الأتمتة',
        runAllNow: 'تشغيل الآن',
        runAllTooltip: 'تشغيل جميع الأتمتات الآن',
        runningInBackground: 'الأتمتات قيد التشغيل في الخلفية...',
        errorRunning: 'خطأ في التشغيل',
        totalAutomations: 'إجمالي الأتمتات',
        active: 'نشطة',
        runs30days: 'مرات التشغيل (30 يومًا)',
        successRate: 'معدل النجاح',
        tabMy: 'الأتمتات الخاصة بي',
        tabHistory: 'سجل التشغيل',
        tabTemplates: 'القوالب',
        noAutomations: 'لا توجد أتمتات بعد. أنشئ الأولى أو اختر قالبًا!',
        noRuns: 'لا توجد عمليات تشغيل بعد',
        filters: 'عوامل التصفية',
        output: 'الإخراج',
        runsCount: 'مرات التشغيل',
        lastRun: 'آخر تشغيل',
        outputEmail: 'إرسال بالبريد الإلكتروني',
        outputWebhook: 'Webhook (Zapier/Make)',
        outputDownload: 'تنزيل كملف PDF',
        outputEmailWebhook: 'بريد إلكتروني + Webhook',
        formatText: 'نص حر',
        formatJson: 'JSON منظّم',
        formatTable: 'جدول',
        formatSummary: 'ملخص نقطي',
        statusSuccess: 'نجاح',
        statusFailed: 'فشل',
        statusProcessing: 'جارٍ المعالجة...',
        statusSkipped: 'تم التخطي',
        automationUpdated: 'تم تحديث الأتمتة',
        automationCreated: 'تم إنشاء الأتمتة',
        automationDeleted: 'تم حذف الأتمتة',
        deleteConfirm: 'هل تريد حذف هذه الأتمتة؟',
        testCompleted: 'اكتمل الاختبار بنجاح',
        testTimeout: 'استغرق الاختبار وقتًا طويلًا. حاول مرة أخرى.',
        testConnectionLost: 'انقطع الاتصال بالخادم. قد يكون الخادم قيد إعادة التشغيل – حاول مرة أخرى بعد 30 ثانية.',
        testFailed: 'فشل الاختبار – تحقق من إعدادات AI وصندوق البريد',
        downloadPdfError: 'خطأ في تنزيل PDF',
        useTemplate: 'استخدام القالب',
        downloadPdf: 'تنزيل كملف PDF',
        stepTrigger: 'المشغّل وعوامل التصفية',
        stepAi: 'معالجة AI',
        stepOutput: 'الإخراج والتسليم',
        automationName: 'اسم الأتمتة',
        descriptionOptional: 'الوصف (اختياري)',
        filterFrom: 'من (العنوان أو جزء منه، يدعم /regex/)',
        filterFromHelper: 'افصل بين العناوين المتعددة بفواصل. مثال: accounting@, billing@company.com أو /.*@company\\.co\\.il/',
        filterSubject: 'الموضوع يحتوي على (كلمات مفتاحية مفصولة بفواصل)',
        filterSubjectHelper: 'مثال: فاتورة,إيصال,طلبية',
        filterBody: 'النص يحتوي على (كلمات مفتاحية)',
        blockedSenders: 'المرسلون المحظورون',
        blockedSendersHelper: 'عناوين بريد إلكتروني أو نطاقات للحظر، مفصولة بفواصل. مثال: spam@example.com, noreply@domain.com',
        onlyWithAttachment: 'فقط الرسائل التي تحتوي على مرفقات',
        fileType: 'نوع الملف',
        fileTypeAll: 'الكل',
        fileTypeImage: 'صورة',
        fileTypeAny: 'أي نوع',
        aiEngine: 'محرك AI',
        aiDefault: 'افتراضي (من الإعدادات)',
        aiOpenai: 'OpenAI (GPT-4o) – الأفضل لملفات Excel',
        aiAnthropic: 'Anthropic (Claude) – الأفضل لملفات PDF',
        aiGoogle: 'Google (Gemini) – سريع وفعّال',
        outputFormat: 'صيغة الإخراج',
        aiPrompt: 'موجّه AI (تعليمات المعالجة)',
        aiPromptHelper: 'يمكنك استخدام المتغيرات: {email_body}, {attachment_content}, {sender}, {subject}, {date}',
        includeBody: 'تضمين نص الرسالة',
        includeAttachments: 'تضمين المرفقات',
        aiTips: 'نصائح:',
        aiTipsText: 'يتميز Claude بقراءة ملفات PDF المعقدة. يتميز GPT-4o بتحليل الجداول والأرقام. Gemini سريع وفعّال للمعالجة الكبيرة.',
        outputType: 'نوع الإخراج',
        sendTarget: 'وجهة الإرسال',
        sendToSelf: 'حسابي (افتراضي)',
        sendToSender: 'الرد على المرسل',
        sendToCustom: 'عنوان مخصص',
        customEmail: 'عنوان بريد إلكتروني مخصص',
        customEmailHelper: 'مثال: ops@company.com',
        emailSubjectTemplate: 'قالب موضوع الرسالة',
        emailSubjectHelper: 'يمكنك استخدام: {subject}, {automation_name}',
        attachAsPdf: 'إرفاق النتيجة كملف PDF',
        webhookHeaders: 'ترويسات Webhook (JSON، اختياري)',
        webhookInfo: 'سيرسل Webhook بيانات JSON بالحقول التالية: automation_name, trigger (from, subject, date), result (text, format). إذا كانت صيغة الإخراج JSON، فسيحتوي الحقل result.parsed على بيانات JSON المحلّلة.',
        limits: 'القيود',
        maxRunsPerDay: 'الحد الأقصى لمرات التشغيل يوميًا',
        activeHoursStart: 'ساعة البداية',
        activeHoursEnd: 'ساعة النهاية',
        enableImmediately: 'تفعيل الأتمتة فور الحفظ',
        testResultTitle: 'نتيجة الاختبار',
        aiResult: 'نتيجة AI:',
        sentTo: 'أُرسلت إلى:',
        inputSentToAi: 'المدخلات المرسلة إلى AI:',
        processingTime: 'وقت المعالجة:',
        testedWithReal: 'تم الاختبار برسالة حقيقية',
        testedWithMock: 'تم الاختبار برسالة تجريبية (لم يتم العثور على رسالة حقيقية في صندوق الوارد)',
        createAutomation: 'إنشاء أتمتة',
        fromFilter: 'من:',
        subjectFilter: 'الموضوع:',
        attachment: 'مرفق',
        // Multi-output (filing / cloud)
        additionalOutputs: 'مخرجات إضافية',
        fileToCloud: 'أرشِف أيضًا في Google Drive / Dropbox',
        filingConnection: 'اتصال الأرشفة',
        filingFolderPath: 'مسار المجلد المستهدف (اختياري)',
        filingFolderHelper: 'مفصول بـ "/". يدعم المتغيرات: {date}, {subject}, {from_name}, {automation_name} وحقول JSON من مخرجات AI.',
        fileAttachments: 'أرشفة المرفقات',
        fileEmailBody: 'أرشفة نص الرسالة',
        fileAiResult: 'أرشفة نتيجة AI',
        noFilingConnections: 'لا يوجد اتصال نشط بـ Google Drive / Dropbox. أضف اتصالًا في صفحة "الأرشفة" لتفعيل هذا الخيار.',
        filingNeedsConnection: 'يلزم وجود اتصال Drive/Dropbox لتفعيل الأرشفة كمخرج.',
        emailBodyTemplate: 'قالب نص الرسالة (اختياري)',
        emailBodyHelper: 'إذا تُرك فارغًا، سيكون نص الرسالة هو مخرجات AI الخام. يدعم نفس المتغيرات المتاحة لسطر الموضوع.',
        templateVarsHelper: 'المتغيرات المتاحة: {subject}, {from_name}, {from}, {date}, {date:dd/MM}, {ai_result} (وأيضًا {ai_text}). إذا كانت مخرجات AI بصيغة JSON، فتتوفر أيضًا {{vendor}}, {{amount}}, {ai_json.amount} وغيرها.',
        // Workflow output targets
        createTaskOption: 'إنشاء مهمة أتمتة (Task Manager)',
        generateReplyDraftOption: 'إنشاء مسودة رد للموافقة (Smart Reply)',
        sendAlertOption: 'إرسال تنبيه عاجل (Alert)',
        taskDefaultStatus: 'الحالة الافتراضية',
        taskDefaultPriority: 'الأولوية',
        taskDefaultTags: 'الوسوم (مفصولة بفواصل)',
        taskStatusOpen: 'مفتوحة',
        taskStatusUrgent: 'عاجلة',
        taskStatusWaitingSupplier: 'بانتظار المورد',
        taskStatusWaitingCustomer: 'بانتظار العميل',
        taskPriorityLow: 'منخفضة',
        taskPriorityMedium: 'متوسطة',
        taskPriorityHigh: 'عالية',
        taskPriorityUrgent: 'عاجلة',
        taskJsonHint: 'نصيحة: لتمكين AI من تحديد العنوان/الحالة/الأولوية ديناميكيًا، استخدم ai_output_format=json واطلب في الموجّه إرجاع { title, summary, status, priority, tags, followup_hours }.',
        replyDraftDefaultTo: 'المستلم الافتراضي',
        replyDraftDefaultToHelper: 'احتفظ بـ "__sender__" للرد على المرسل الأصلي، أو أدخل بريدًا إلكترونيًا ثابتًا.',
        alertRecipientsLabel: 'مستلمو التنبيه (مفصولون بفواصل)',
        alertRecipientsHelper: 'إذا تُرك فارغًا، يُرسل التنبيه إلى حساب الأتمتة. كما يُرسل إشعار push إلى المستخدم.',
        // Trigger types
        triggerSection: 'المشغّل',
        triggerType: 'نوع المشغّل',
        triggerEmail: 'بريد وارد (افتراضي)',
        triggerSchedule: 'مجدول (ملخص يومي / تقرير)',
        triggerFollowup: 'متابعة تلقائية للمهام المفتوحة',
        scheduleTime: 'وقت الجدولة',
        scheduleDays: 'الأيام النشطة',
        scheduleDaysHelper: '0=الأحد, 1=الاثنين, ..., 6=السبت',
        followupWaitHours: 'عدد ساعات الانتظار قبل المتابعة',
        followupWaitHelper: 'ستُفعّل الأتمتة متابعة للمهام التي لم يتم تحديثها خلال هذه الفترة.',
        scheduleTimeInvalid: 'يجب أن يكون وقت الجدولة بصيغة HH:MM',
        followupWaitInvalid: 'لمشغّل المتابعة، أدخل عدد ساعات موجبًا',
        // Reference materials (knowledge base files attached to the prompt)
        referenceMaterials: 'المواد المرجعية لهذه الأتمتة',
        referenceMaterialsHelper: 'ملفات أو روابط مرجعية سيتم إرفاقها في كل تشغيل. مفيدة لجداول الحد الأدنى للطلبات وقوائم الأسعار وقوائم العملاء وغيرها. تُنزَّل جداول Google Sheets العامة تلقائيًا بصيغة CSV.',
        addReferenceMaterial: 'إضافة مادة مرجعية',
        referenceMaterialName: 'اسم وصفي',
        referenceMaterialUrl: 'الرابط (Google Sheet / Drive / رابط مباشر)',
        referenceMaterialUrlHelper: 'يُنزَّل جدول Google Sheet العام تلقائيًا بصيغة CSV. لملف Drive خاص، شاركه مع "أي شخص لديه الرابط".',
        referenceMaterialRemove: 'إزالة',
        // Task manager
        tasksTitle: 'المهام المفتوحة',
        taskUpdated: 'تم تحديث المهمة',
        taskUpdateError: 'خطأ في تحديث المهمة',
        taskDeleteConfirm: 'هل تريد حذف المهمة؟ لا يمكن التراجع عن هذا الإجراء.',
        taskDeleted: 'تم حذف المهمة',
        taskDeleteError: 'خطأ في الحذف',
        taskFilterOpenOnly: 'المفتوحة فقط',
        taskFilterUrgent: 'عاجلة',
        taskFilterOpen: 'مفتوحة',
        taskFilterWaitingSupplier: 'بانتظار المورد',
        taskFilterWaitingCustomer: 'بانتظار العميل',
        taskFilterClosed: 'مغلقة',
        taskFilterAll: 'الكل',
        tasksCount: '{count} مهام',
        taskColTitle: 'العنوان / الملخص',
        taskColSource: 'المصدر',
        taskColAutomation: 'الأتمتة',
        taskColLastAction: 'آخر إجراء',
        noOpenTasks: 'لا توجد مهام مفتوحة حاليًا',
        tasksAutoInfo: 'المهام التي تُنشأ تلقائيًا من الرسائل ستظهر هنا.',
        taskStatusClosed: 'مغلق',
        taskPrioUrgent: 'عاجل',
        taskPrioHigh: 'مرتفع',
        taskPrioMedium: 'متوسط',
        taskPrioLow: 'منخفض',
        taskReopen: 'إعادة فتح',
        taskCloseTask: 'إغلاق المهمة',
        refNamePlaceholder: 'جدول الحد الأدنى للطلب',
        emailBodyPlaceholder: 'مثال: مرحبًا,\nفاتورة جديدة من {from_name}.\nالمورد: {{المورد}}, المبلغ: {{المبلغ}}.\n\n{ai_result}',
        filingPathPlaceholder: '{date}/أتمتة/{from_name}',
        refMaterialsLoadedSummary: 'مواد مرجعية: تم تحميل {ok}/{total}',
        extractWarningPrefix: 'خطأ في تحميل محتوى البريد / الملفات:',
        refMaterialsLoadedTitle: 'المواد المرجعية المحملة ({ok}/{total})',
        downloadedFile: 'ملف تم تنزيله:',
        refMaterialChip: 'مادة مرجعية',
    },

    // ==================== FILING ====================
    filing: {
        title: 'أرشفة المستندات الذكية',
        subtitle: 'أرشفة مرفقات البريد الإلكتروني تلقائيًا إلى السحابة باستخدام AI',
        skippedNoDocument: 'لم يتم العثور على مستند قابل للتنزيل في الرابط',
        retryFailedBtn: 'إعادة المحاولة (الفاشلة)',
        retryFailedSuccess: 'تمت إعادة جدولة المهام الفاشلة',
        retryFailedError: 'خطأ في إعادة تعيين المهام',
        moduleDesc: 'أرشِف مرفقات البريد الإلكتروني مباشرة إلى Google Drive أو Dropbox – تلقائيًا باستخدام AI. يتعرف النظام على الفواتير والطلبيات والعقود وغيرها، ويؤرشفها في مجلدات منظمة.',
        moduleFeatures: ['Google Drive', 'Dropbox', 'التعرف على المستندات بالـ AI', 'مجلدات تلقائية', 'تصفية ذكية'],
        newRule: 'قاعدة أرشفة جديدة',
        editRule: 'تعديل قاعدة الأرشفة',
        activeRules: 'القواعد النشطة',
        filesFiled: 'الملفات المؤرشفة',
        todayFilings: 'أُرشفت اليوم',
        cloudConnections: 'اتصالات السحابة',
        tabConnections: 'اتصالات السحابة',
        tabRules: 'قواعد الأرشفة',
        tabHistory: 'السجل',
        googleDriveDesc: 'أرشِف المرفقات مباشرة إلى Google Drive. سينشئ النظام المجلدات تلقائيًا بناءً على إعدادات AI.',
        dropboxDesc: 'أرشِف المرفقات مباشرة إلى Dropbox. سينشئ النظام المجلدات تلقائيًا بناءً على إعدادات AI.',
        notConnected: 'غير متصل',
        disconnect: 'قطع الاتصال',
        connectGoogleDrive: 'ربط Google Drive',
        connectDropbox: 'ربط Dropbox',
        connectedSuccess: 'تم الاتصال بنجاح!',
        connectionError: 'خطأ في الاتصال:',
        connectFirst: 'اربط حساب Google Drive أو Dropbox للبدء في أرشفة المستندات تلقائيًا.',
        noRules: 'لا توجد قواعد أرشفة',
        noRulesSubtitle: 'أنشئ قاعدة الأرشفة الأولى للبدء في أرشفة المستندات تلقائيًا من البريد الإلكتروني.',
        connectCloudFirst: 'اربط أولًا حساب سحابة (Google Drive أو Dropbox) في تبويب "اتصالات السحابة"',
        allEmails: 'جميع الرسائل التي تحتوي على ملفات',
        runsToday: 'مرات التشغيل اليوم',
        noHistory: 'لا يوجد سجل أرشفة',
        noHistorySubtitle: 'بمجرد تفعيل قواعد الأرشفة، ستشاهد السجل هنا.',
        rule: 'القاعدة',
        sender: 'المرسل',
        filesCount: 'الملفات',
        disconnectConfirm: 'هل أنت متأكد؟ ستتوقف قواعد الأرشفة التي تستخدم هذا الاتصال عن العمل.',
        connectionRemoved: 'تمت إزالة الاتصال',
        errorDisconnect: 'خطأ في إزالة الاتصال',
        errorConnection: 'خطأ في الاتصال',
        ruleUpdated: 'تم تحديث القاعدة',
        ruleCreated: 'تم إنشاء القاعدة بنجاح',
        ruleDeleted: 'تم حذف القاعدة',
        deleteRuleConfirm: 'هل تريد حذف قاعدة الأرشفة هذه؟',
        errorToggle: 'خطأ في تغيير الحالة',
        manualRunStarted: 'بدأ التشغيل اليدوي',
        errorManualRun: 'خطأ في بدء التشغيل اليدوي',
        testResult: 'نتيجة الاختبار',
        aiClassified: 'صنّف AI المستند بنجاح (الثقة: {confidence}%)',
        emailLabel: 'البريد الإلكتروني:',
        fileLabel: 'الملف:',
        docType: 'نوع المستند:',
        filingPath: 'مسار الأرشفة:',
        filePath: 'المسار',
        fileLink: 'الرابط',
        fileName: 'اسم الملف:',
        destination: 'الوجهة:',
        stepSource: 'المصدر وعوامل التصفية',
        stepAi: 'تعليمات AI',
        stepDestination: 'الوجهة والقيود',
        ruleName: 'اسم القاعدة',
        imapFolder: 'مجلد IMAP',
        imapDefault: 'الافتراضي: INBOX',
        filterOptional: 'عوامل التصفية (اختياري)',
        filterFrom: 'من (المرسل)',
        filterFromHelper: 'عنوان بريد إلكتروني، أو جزء منه، أو عناوين مفصولة بفواصل. اتركه فارغًا = جميع المرسلين',
        filterSubject: 'الموضوع يحتوي على',
        filterSubjectHelper: 'كلمات مفتاحية في الموضوع، مفصولة بفواصل',
        filterBody: 'نص الرسالة يحتوي على',
        filterAttachment: 'اسم المرفق يحتوي على',
        filterAttachmentHelper: 'مثلًا: "فاتورة"، "طلبية"، "عقد"',
        blockedSenders: 'المرسلون المحظورون',
        blockedSendersHelper: 'عناوين بريد إلكتروني أو نطاقات للحظر، مفصولة بفواصل. مثال: spam@example.com, noreply@domain.com',
        aiInstructions: 'صِف كيف تريد أرشفة المستندات. إذا تُرك فارغًا، سيستخدم AI الطريقة الافتراضية: السنة > اسم المرسل > نوع المستند (فاتورة/طلبية/عقد/عام).',
        filingPrompt: 'تعليمات الأرشفة (Prompt) — اختياري',
        filingPromptPlaceholder: 'أمثلة:\n\n• "نظّم في مجلدات حسب: السنة > اسم العميل > نوع المستند (فواتير، طلبيات، عقود)"\n\n• "أرشِف كل شيء في مجلد واحد باسم \'مستندات واردة\' مع التاريخ كبادئة"\n\n• "فواتير الموردين في \'المصروفات > السنة > الشهر\'، وفواتير العملاء في \'الإيرادات > السنة\'"\n\n• "ملفات PDF التي تحتوي على \'فاتورة\' - مجلد الفواتير. ملفات Excel - مجلد التقارير. الباقي - المجلد العام"',
        aiEngineOptional: 'محرك AI (اختياري)',
        modelOptional: 'النموذج (اختياري)',
        modelHelper: 'اتركه فارغًا لاستخدام النموذج الافتراضي',
        cloudTarget: 'وجهة السحابة',
        targetFolder: 'المجلد المستهدف:',
        rootFolder: 'المجلد الجذر',
        resetToRoot: 'إعادة التعيين إلى المجلد الجذر',
        browseFolder: 'استعراض / إنشاء مجلد جديد',
        limitsLabel: 'القيود',
        maxRunsDay: 'الحد الأقصى لمرات التشغيل يوميًا',
        startHour: 'ساعة البداية',
        endHour: 'ساعة النهاية',
        activeDays: 'الأيام النشطة:',
        enableAfterCreate: 'تفعيل القاعدة فور الإنشاء',
        selectFolder: 'اختيار المجلد المستهدف',
        noSubfolders: 'لا توجد مجلدات فرعية هنا',
        noFolders: 'لا توجد مجلدات',
        createOrSelect: 'أنشئ مجلدًا جديدًا أو اختر المجلد الحالي',
        newFolderName: 'اسم المجلد الجديد',
        createFolder: 'إنشاء',
        folderCreated: 'تم إنشاء المجلد بنجاح',
        errorCreateFolder: 'خطأ في إنشاء المجلد',
        selectThisFolder: 'اختر هذا المجلد',
        selectCloudFirst: 'اختر اتصال سحابة أولًا',
        nameRequired: 'اسم القاعدة مطلوب',
        accountRequired: 'حساب البريد الإلكتروني مطلوب',
        missingRuleName: 'اسم القاعدة مفقود (الخطوة 1)',
        missingAccount: 'حساب البريد الإلكتروني مفقود (الخطوة 1)',
        missingCloud: 'وجهة السحابة مفقودة',
        createRule: 'إنشاء قاعدة',
        fromPrefix: 'من:',
        subjectPrefix: 'الموضوع:',
        filePrefix: 'الملف:',
        daysShort: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
    },

    // ==================== INBOX (Webmail) ====================
    inbox: {
        compose: 'إنشاء رسالة',
        reply: 'رد',
        replyAll: 'رد على الكل',
        forward: 'إعادة توجيه',
        forwardAttachmentsFailed: 'تعذّر تحميل مرفق (مرفقات) لإعادة التوجيه — حاول مرة أخرى أو أرفقها يدويًا',
        to: 'إلى',
        cc: 'نسخة',
        bcc: 'نسخة مخفية',
        subject: 'الموضوع',
        noSubject: '(بدون موضوع)',
        send: 'إرسال',
        sending: 'جارٍ الإرسال...',
        emailSent: 'تم إرسال الرسالة بنجاح!',
        readReceipt: 'إيصال قراءة',
        openTracking: 'تتبع الفتح',
        priority: 'الأولوية',
        priorityHigh: 'أولوية عالية',
        priorityNormal: 'عادي',
        priorityLow: 'أولوية منخفضة',
        encryption: 'التشفير',
        schedule: 'جدولة',
        templates: 'القوالب',
        addAttachment: 'إضافة ملف',
        attachments: 'المرفقات',
        dragFiles: 'اسحب الملفات إلى هنا أو انقر "إضافة ملف"',
        snooze: 'تذكير / تأجيل',
        snooze1h: 'بعد ساعة',
        snooze3h: 'بعد 3 ساعات',
        snoozeTomorrow: 'صباح الغد',
        snooze2d: 'بعد يومين',
        snooze1w: 'بعد أسبوع',
        addStar: 'إضافة نجمة',
        removeStar: 'إزالة النجمة',
        selected: 'محدد',
        deleteSelected: 'حذف المحدد',
        moveToArchive: 'نقل إلى الأرشيف',
        markRead: 'وضع علامة كمقروء',
        markUnread: 'وضع علامة كغير مقروء',
        moveToFolder: 'نقل إلى مجلد',
        deselectAll: 'إلغاء تحديد الكل',
        connecting: 'جارٍ الاتصال بصندوق البريد...',
        noResults: 'لم يتم العثور على نتائج',
        emptyFolder: 'المجلد فارغ',
        inbox: 'الوارد',
        sentMail: 'المرسلة',
        drafts: 'المسودات',
        spam: 'الرسائل المزعجة',
        trash: 'المهملات',
        archive: 'الأرشيف',
        flagged: 'المميزة بنجمة',
        allMail: 'كل البريد',
        primary: 'الأساسي',
        social: 'التواصل الاجتماعي',
        promotions: 'العروض الترويجية',
        updates: 'التحديثات',
        quickReplyPlaceholder: 'رد سريع...',
        sendQuickReply: 'إرسال',
        quickReplySent: 'تم إرسال الرد السريع!',
        composePlaceholder: 'اكتب رسالتك هنا...',
        addressPlaceholder: 'أدخل العنوان...',
        searchPlaceholder: 'البحث في الرسائل...',
        aiAssist: 'مساعد الكتابة AI',
        aiCompose: 'الكتابة باستخدام AI',
        aiTones: {
            professional: 'احترافي',
            friendly: 'ودّي',
            brief: 'مختصر',
            formal: 'رسمي',
            thankful: 'ممتن',
            decline: 'اعتذار مهذب',
        },
        aiTonesDesc: {
            professional: 'رد احترافي ومهذب',
            friendly: 'دافئ وشخصي',
            brief: 'مباشر إلى الموضوع، 3-4 جمل',
            formal: 'مثل رسالة عمل رسمية',
            thankful: 'تعبير عن التقدير',
            decline: 'اعتذار لطيف مع بديل',
        },
        errorSendingEmail: 'خطأ في إرسال الرسالة',
        errorLoadingMessage: 'خطأ في تحميل الرسالة',
        deleteConfirm: 'هل تريد حذف هذه الرسائل؟',
        newFolder: 'مجلد جديد',
        renameFolder: 'إعادة تسمية',
        deleteFolder: 'حذف المجلد',
        folderName: 'اسم المجلد',
        wrote: 'كتب',
        forwardedMessage: 'رسالة معاد توجيهها',
        fromLabel: 'من:',
        dateLabel: 'التاريخ:',
        subjectLabel: 'الموضوع:',
        printEmail: 'طباعة',
        downloadEmail: 'تنزيل',
        unifiedInbox: 'صندوق الوارد الموحّد',
        newMail: 'بريد جديد',
        newMailBody: 'لديك {count} رسالة جديدة',
        connectionError: 'خطأ في الاتصال بصندوق البريد',
        connectionCooldown: 'الاتصال في فترة انتظار مؤقتة بسبب إخفاقات سابقة. جارٍ محاولة إعادة التعيين...',
        resetDone: 'تمت إعادة التعيين - جارٍ إعادة الاتصال...',
        reconnectingAccount: 'رفض خادم البريد الاتصال مؤقتًا - جارٍ إعادة المحاولة...',
        cannotAutoReset: 'تعذّرت إعادة التعيين التلقائية - تواصل مع المسؤول',
        mailboxUnavailable: 'صندوق البريد {email} غير متاح حاليًا، جارٍ التبديل إلى آخر...',
        errorLoadingMessages: 'خطأ في تحميل الرسائل',
        errorLoadingUnified: 'خطأ في تحميل صندوق البريد الموحّد',
        errorAiReply: 'خطأ في إنشاء رد AI',
        errorAiCompose: 'خطأ في الكتابة باستخدام AI',
        errorEncryption: 'خطأ في التشفير',
        sendWithoutEncryption: 'هل تريد الإرسال بدون تشفير؟',
        errorSendingPrefix: 'خطأ في الإرسال: ',
        chooseDateTime: 'يرجى اختيار التاريخ والوقت',
        emailScheduled: 'تمت جدولة الرسالة بنجاح!',
        errorSchedulingPrefix: 'خطأ في الجدولة: ',
        errorCreatingFolderPrefix: 'خطأ في إنشاء المجلد: ',
        errorDeletingFolderPrefix: 'خطأ في حذف المجلد: ',
        errorExportPrefix: 'خطأ في التصدير: ',
        confirmDeleteSearch: 'هل تريد حذف جميع الرسائل الـ {count} المطابقة للبحث "{query}"؟',
        errorDeletingSearchPrefix: 'خطأ في حذف جميع نتائج البحث: ',
        errorDeletingPrefix: 'خطأ في الحذف: ',
        confirmEmptyFolder: 'هل تريد إفراغ "{folder}"؟ سيتم حذف جميع الرسائل نهائيًا ولا يمكن استعادتها.',
        errorEmptyingFolderPrefix: 'خطأ في إفراغ المجلد: ',
        confirmMoveSearch: 'هل تريد نقل جميع الرسائل الـ {count} المطابقة للبحث "{query}" إلى مجلد؟',
        errorMovingSearchPrefix: 'خطأ في نقل جميع نتائج البحث: ',
        errorMovingPrefix: 'خطأ في النقل: ',
        confirmSpamSearch: 'هل تريد الإبلاغ عن جميع الرسائل الـ {count} المطابقة كرسائل مزعجة؟',
        errorSpamSearchPrefix: 'خطأ في الإبلاغ عن جميع نتائج البحث كرسائل مزعجة: ',
        confirmMoveToInbox: 'هل تريد نقل جميع الرسائل الـ {count} المطابقة إلى صندوق الوارد؟',
        errorMoveToInboxPrefix: 'خطأ في نقل جميع نتائج البحث إلى صندوق الوارد: ',
        archiveNotFound: 'لم يتم العثور على مجلد الأرشيف',
        toLabel: 'إلى:',
        ccLabel: 'نسخة:',
        noName: 'بدون اسم',
        lastMsg: 'الأحدث',
        firstMsg: 'الأول',
        noText: '(بدون نص)',
        noContent: '(بدون محتوى)',
        noMessageContent: 'لا يوجد محتوى لهذه الرسالة.',
        pgpPassphrasePrompt: 'أدخل عبارة مرور التشفير:',
        noEncryptedContent: 'لم يتم العثور على محتوى مشفّر',
        decryptedContent: 'المحتوى المفكوك:',
        errorDecryption: 'خطأ في فك التشفير',
        decrypt: 'فك التشفير',
        pgpEncrypted: 'هذه الرسالة مشفّرة بـ PGP',
        readReceiptSent: 'تم إرسال إيصال القراءة',
        errorSendingReadReceipt: 'خطأ في إرسال إيصال القراءة',
        sendConfirmation: 'إرسال تأكيد',
        senderRequestedReadReceipt: 'طلب المرسل إيصال قراءة لهذه الرسالة',
        autoReplied: 'تم الرد تلقائيًا',
        autoRepliedByAI: 'تم الرد تلقائيًا بواسطة AI',
        aiReplyTooltip: 'الرد باستخدام AI - رد تلقائي',
        aiReplyLabel: 'رد AI',
        errorArchive: 'خطأ في النقل إلى الأرشيف',
        errorDelete: 'خطأ في الحذف',
        notSpamTooltip: 'ليست رسالة مزعجة - انقل إلى صندوق الوارد',
        reportSpamTooltip: 'الإبلاغ كرسالة مزعجة',
        createCalendarEvent: 'إنشاء حدث في التقويم',
        openNewWindow: 'فتح في نافذة جديدة',
        exportEml: 'تصدير كملف ‎.eml',
        aiCategorize: 'تصنيف تلقائي بالـ AI',
        classifyResult: 'الفئة',
        errorClassify: 'خطأ في التصنيف التلقائي',
        labelsTitle: 'التسميات',
        noLabelsHint: 'لا توجد تسميات - أنشئها في الإعدادات',
        closePreview: 'إغلاق المعاينة',
        snoozeSet: 'تم ضبط التذكير',
        errorSnooze: 'خطأ في ضبط التذكير',
        emailFrom: 'رسالة من:',
        eventCreated: 'تم إنشاء الحدث بنجاح في التقويم!',
        errorCreatingEvent: 'خطأ في إنشاء الحدث',
        addAccount: '+ إضافة حساب',
        demo: 'تجريبي',
        emptyAction: 'إفراغ',
        welcomeTitle: 'مرحبًا بك في صندوق بريدك',
        welcomeSubtitle: 'اربط حساب بريدك الإلكتروني لبدء استقبال الرسائل وإرسالها. يمكنك ربط Gmail أو Outlook أو أي حساب IMAP.',
        connectMailbox: 'ربط صندوق البريد',
        connectHelpGuide: 'دليل ربط Gmail',
        connectHelpWhatsapp: 'مساعدة عبر واتساب',
        connectBannerTitle: 'لم تربط صندوق بريد بعد',
        connectBannerBody: 'بدون صندوق متصل لا يمكن قراءة البريد أو استخدام الذكاء الاصطناعي. يستغرق الأمر دقيقة تقريباً.',
        connectBannerCta: 'اربط الصندوق الآن',
        connectBannerDismiss: 'لاحقاً',
        tryAgain: 'حاول مرة أخرى',
        unread: 'غير مقروءة',
        attachmentsFilter: 'ملفات',
        advancedSearch: 'بحث متقدم',
        dateFrom: 'من تاريخ',
        dateTo: 'إلى تاريخ',
        searchInBody: 'البحث في النص',
        clearFilters: 'مسح',
        paginationOf: 'من',
        firstPage: 'الصفحة الأولى',
        nextPage: 'الصفحة التالية',
        prevPage: 'الصفحة السابقة',
        lastPage: 'الصفحة الأخيرة',
        show: 'عرض:',
        autoRefresh: 'تحديث تلقائي',
        off: 'إيقاف',
        seconds30: '30 ثانية',
        minute1: 'دقيقة واحدة',
        minutes2: 'دقيقتان',
        minutes5: '5 دقائق',
        createEventFromEmail: 'إنشاء حدث في التقويم من الرسالة',
        eventTitle: 'العنوان',
        eventDescription: 'الوصف',
        eventLocation: 'الموقع',
        eventStart: 'البداية',
        eventEnd: 'النهاية',
        createEventBtn: 'إنشاء حدث',
        addMailAccount: 'إضافة حساب بريد إلكتروني',
        connectToMailbox: 'الاتصال بصندوق البريد',
        loginPrompt: 'أدخل عنوان بريدك الإلكتروني وكلمة المرور. سيتم حفظ بيانات الاعتماد حتى لا تحتاج إلى إدخالها مرة أخرى.',
        emailAddress: 'عنوان البريد الإلكتروني',
        passwordLabel: 'كلمة المرور',
        useAppPassword: 'استخدم App Password (انظر الدليل أدناه)',
        protocol: 'البروتوكول',
        localStorage: 'التخزين المحلي',
        pop3Warning: 'مناسب للخوادم القديمة. القيود: INBOX فقط، بدون مزامنة حالة القراءة، بدون بحث على الخادم.',
        localCacheInfo: 'سيتم حفظ الرسائل محليًا للتحميل السريع والوصول دون اتصال.',
        addAndConnect: 'إضافة وربط',
        connect: 'اتصال',
        connectGmail: 'ربط Gmail',
        connectWorkspace: 'ربط Google Workspace / حساب IMAP',
        openAppPasswords: 'افتح App Passwords في Google ↗',
        gmailAppPasswordInfo: 'يتطلب Gmail استخدام App Password بدلًا من كلمة مرورك العادية.',
        gmailStep1: 'انتقل إلى myaccount.google.com/security',
        gmailStep2: 'فعّل التحقق بخطوتين (2-Step Verification) إذا لم يكن مفعّلًا',
        gmailStep3: 'ابحث عن "App Passwords"',
        gmailStep4: 'أنشئ كلمة مرور تطبيق جديدة لـ "Mail" → انسخ الرمز المكوّن من 16 حرفًا',
        gmailStep5: 'الصق الرمز في حقل كلمة المرور أعلاه (بدون مسافات)',
        workspaceInfo: 'لحسابات Google Workspace (نطاق أعمال) أو حسابات IMAP الأخرى:',
        workspaceStep1: '1. تأكد من تفعيل IMAP في إعدادات الحساب',
        workspaceStep2: '2. إذا كان التحقق بخطوتين مفعّلًا، أنشئ App Password',
        workspaceStep3: '3. أدخل عنوان البريد الإلكتروني الكامل وكلمة مرور التطبيق',
        demoMode: 'الوضع التجريبي',
        autoFill: 'تعبئة تلقائية',
        sendFrom: 'الإرسال من',
        sendAs: 'الإرسال باسم',
        aiComposeDesc: 'صِف ما تريد كتابته، وسيُعِدّ AI رسالة جاهزة للإرسال مع سطر موضوع.',
        aiComposePlaceholder: 'صِف الرسالة التي تريد إرسالها...',
        aiComposing: 'جارٍ الكتابة...',
        aiComposeBtn: 'كتابة رسالة',
        aiGenerating: 'AI ينشئ ردًا...',
        aiGenerateReply: 'إنشاء رد باستخدام AI',
        chooseTone: 'اختر نبرة الرد',
        aiExample1: 'صِغ عقد عمل لموظفنا الجديد',
        aiExample2: 'اكتب رسالة ملخص اجتماع بناءً على النقاط التالية:',
        aiExample3: 'لخّص المقال التالي لنشرة بريدية:',
        aiExample4: 'اكتب رسالة احترافية لشراكة تجارية',
        aiExample5: 'صِغ عرض سعر لعميل يطلب خدمات استشارية',
        aiExample6: 'اكتب ردًا مهذبًا على شكوى عميل',
        aiExample7: 'صِغ دعوة إلى مؤتمر / فعالية للشركة',
        aiExample8: 'اكتب رسالة متابعة بعد اجتماع عمل',
        trackingStats: 'إحصاءات التتبع',
        trackingStatsTitle: 'إحصاءات تتبع البريد الإلكتروني',
        noTrackingData: 'لا توجد بيانات تتبع بعد. أرسل رسالة مع تفعيل "تتبع الفتح" لرؤية الإحصاءات.',
        sentOn: 'أُرسلت',
        openedOn: 'فُتحت',
        openedTimes: 'فُتحت {count} مرة',
        pgpTooltip: 'تشفير PGP - سيتم تشفير الرسالة بالمفتاح العام للمستلم',
        createFolder: 'إنشاء مجلد',
        deleteFolderWarning: 'سيؤدي هذا إلى حذف المجلد',
        deleteFolderConfirm: 'هل أنت متأكد أنك تريد حذف هذا المجلد؟ لا يمكن التراجع عن هذا الإجراء.',
        confirmDeleteFolder: 'نعم، احذف المجلد',
        deleteMailAccount: 'حذف حساب البريد الإلكتروني',
        confirmDeleteAccount: 'هل أنت متأكد أنك تريد حذف الحساب',
        deleteAccountWarning: 'سيؤدي هذا إلى إزالة الحساب من جميع أجهزتك. يمكنك إضافته مرة أخرى في أي وقت.',
        confirmDelete: 'تأكيد الحذف',
        scheduleEmail: 'جدولة الرسالة',
        scheduleDateLabel: 'تاريخ ووقت الإرسال',
        scheduling: 'جارٍ الجدولة...',
        scheduleSend: 'جدولة الإرسال',
        undoSendMsg: 'سيتم إرسال الرسالة خلال 5 ثوانٍ...',
        undoSend: 'التراجع عن الإرسال',
        allSearchSelected: 'تم تحديد جميع الرسائل الـ {count} المطابقة للبحث "{query}".',
        cancelSelectAll: 'إلغاء تحديد الكل',
        allPageSelected: 'تم تحديد جميع الرسائل الـ {count} في هذه الصفحة.',
        selectAllSearchResults: 'تحديد جميع الرسائل الـ {count} المطابقة',
        onboardingTitle: 'مرحبًا بك في Email Lion!',
        onboardingStep1: 'مرحبًا',
        onboardingStep2: 'المجلدات',
        onboardingStep3: 'الكتابة',
        onboardingStep4: 'نصائح',
        onboarding1Title: 'نظام بريدك الإلكتروني جاهز!',
        onboarding1Desc: 'Email Lion هو نظام بريد إلكتروني متقدم مزوّد بأدوات احترافية لإدارة رسائلك. لنستعرض الميزات الرئيسية.',
        onboarding2Title: 'المجلدات والتنظيم',
        onboarding2Desc: 'في الجانب ستجد مجلدات بريدك. يمكنك إنشاء مجلدات جديدة، وسحب الرسائل بين المجلدات، والتصفية حسب الفئات الذكية.',
        onboarding3Title: 'كتابة رسالة',
        onboarding3Desc: 'انقر "إنشاء رسالة" أو اضغط C على لوحة المفاتيح. يمكنك إرفاق الملفات، وجدولة الإرسال، واستخدام القوالب، وتتبع فتح الرسائل.',
        onboarding4Title: 'نصائح احترافية',
        onboarding4Desc: '• اضغط ? لعرض اختصارات لوحة المفاتيح\n• اضغط / للانتقال إلى البحث\n• استخدم عوامل التصفية السريعة لفرز الرسائل\n• أنشئ توقيعًا شخصيًا في الإعدادات\n• فعّل الوضع الداكن من القائمة العلوية',
        skip: 'تخطي',
        letsStart: 'لنبدأ!',
        keyboardShortcuts: 'اختصارات لوحة المفاتيح',
        kbCompose: 'كتابة رسالة جديدة',
        kbReply: 'الرد على الرسالة',
        kbForward: 'إعادة توجيه الرسالة',
        kbDelete: 'حذف المحدد',
        kbEscape: 'إغلاق / إلغاء التحديد',
        kbSelectAll: 'تحديد الكل',
        kbSearch: 'الانتقال إلى البحث',
        kbHelp: 'المساعدة - الاختصارات',
        dragToReorder: 'اسحب لإعادة الترتيب',
        defaultAccount: 'افتراضي',
        dragReorderHint: 'اسحب لإعادة الترتيب • الأول = الافتراضي',
        cannotConnectMailServer: 'تعذّر الاتصال بخادم البريد. تحقق من صحة عنوان البريد الإلكتروني.',
        cannotTestConnection: 'تعذّر اختبار الاتصال.',
        connectionSaveFailed: 'تم اختبار الاتصال، لكن فشل حفظ صندوق البريد. يرجى المحاولة مرة أخرى.',
        testingConnection: 'جارٍ اختبار الاتصال...',
        loadingOriginalAttachments: 'جارٍ تحميل {count} مرفقًا أصليًا...',
        onDatePrefix: 'في ',
    },

    // ==================== SETTINGS ====================
    settings: {
        title: 'الإعدادات',
        tabGeneral: 'عام',
        tabAi: 'وكيل AI',
        tabSecurity: 'الأمان',
        tabContacts: 'جهات الاتصال',
        tabSignatures: 'التوقيعات',
        tabTemplates: 'القوالب',
        tabRules: 'القواعد',
        tabLabels: 'التسميات',
        tabAlias: 'الأسماء المستعارة',
        tabVacation: 'الرد التلقائي',
        tabSendPermissions: 'صلاحيات الإرسال',
        tabReferral: 'الإحالات',
        viewMode: 'وضع العرض',
        language: 'اللغة',
        theme: 'المظهر',
        notifications: 'الإشعارات',
        changePassword: 'تغيير كلمة المرور',
        currentPassword: 'كلمة المرور الحالية',
        newPassword: 'كلمة مرور جديدة',
        confirmPassword: 'تأكيد كلمة المرور',
        passwordChanged: 'تم تغيير كلمة المرور بنجاح',
        twoFactor: 'المصادقة الثنائية (2FA)',
        enable2FA: 'تفعيل 2FA',
        disable2FA: 'تعطيل 2FA',
        pgpEncryption: 'تشفير PGP',
        addContact: 'إضافة جهة اتصال',
        editContact: 'تعديل جهة الاتصال',
        deleteContact: 'حذف جهة الاتصال',
        contactName: 'الاسم',
        contactEmail: 'البريد الإلكتروني',
        contactPhone: 'الهاتف',
        contactCompany: 'الشركة',
        noContacts: 'لا توجد جهات اتصال',
        addSignature: 'إضافة توقيع',
        editSignature: 'تعديل التوقيع',
        deleteSignature: 'حذف التوقيع',
        defaultSignature: 'التوقيع الافتراضي',
        signatureName: 'اسم التوقيع',
        signatureContent: 'محتوى التوقيع',
        noSignatures: 'لا توجد توقيعات',
        addTemplate: 'إضافة قالب',
        editTemplate: 'تعديل القالب',
        deleteTemplate: 'حذف القالب',
        templateName: 'اسم القالب',
        templateSubject: 'الموضوع',
        templateBody: 'المحتوى',
        noTemplates: 'لا توجد قوالب',
        addRule: 'إضافة قاعدة',
        editRule: 'تعديل القاعدة',
        deleteRule: 'حذف القاعدة',
        noRules: 'لا توجد قواعد',
        ruleName: 'اسم القاعدة',
        ruleCondition: 'الشرط',
        ruleAction: 'الإجراء',
        addLabel: 'إضافة تسمية',
        editLabel: 'تعديل التسمية',
        deleteLabel: 'حذف التسمية',
        noLabels: 'لا توجد تسميات',
        labelName: 'اسم التسمية',
        labelColor: 'اللون',
        vacationReply: 'الرد التلقائي (إجازة)',
        vacationEnabled: 'مفعّل',
        vacationSubject: 'موضوع الرد',
        vacationMessage: 'نص الرد',
        vacationStart: 'تاريخ البداية',
        vacationEnd: 'تاريخ النهاية',
        saved: 'تم الحفظ بنجاح',
        errorSaving: 'خطأ في الحفظ',
        referralTitle: 'برنامج الإحالات',
        referralCode: 'رمز الإحالة الخاص بك',
        referralLink: 'رابط الإحالة',
        copyLink: 'نسخ الرابط',
        linkCopied: 'تم نسخ الرابط!',
        tabAdvanced: 'متقدم',
        referralInvitePrefix: 'ادعُ أصدقاءك إلى Email Lion واحصل على ',
        referralFreeMonth: 'شهر مجاني',
        referralInviteSuffix: ' عن كل صديق يدفع اشتراكًا!',
        referralYourCode: 'رمز الإحالة الخاص بك',
        copied: 'تم النسخ!',
        copyCode: 'نسخ الرمز',
        referralsCount: 'الإحالات',
        rewardsCount: 'المكافآت',
        aiConfigSaved: 'تم حفظ إعدادات AI بنجاح',
        aiConfigError: 'خطأ في حفظ إعدادات AI',
        viewSaved: 'تم حفظ العرض',
        newSignature: 'توقيع جديد',
        signatureSaved: 'تم حفظ التوقيع',
        signatureSaveError: 'خطأ في حفظ التوقيع',
        signatureDeleted: 'تم حذف التوقيع',
        signatureDeleteError: 'خطأ في حذف التوقيع',
        categoryGeneral: 'عام',
        templateNameRequired: 'اسم القالب مطلوب',
        templateSaved: 'تم حفظ القالب',
        templateSaveError: 'خطأ في حفظ القالب',
        templateDeleted: 'تم حذف القالب',
        templateDeleteError: 'خطأ في حذف القالب',
        emailRequired: 'البريد الإلكتروني مطلوب',
        contactSaved: 'تم حفظ جهة الاتصال',
        contactSaveError: 'خطأ في حفظ جهة الاتصال',
        contactDeleteError: 'خطأ في حذف جهة الاتصال',
        passwordsMismatch: 'كلمتا المرور غير متطابقتين',
        passwordMinLength: 'يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل',
        passwordChangeError: 'خطأ في تغيير كلمة المرور',
        twoFASetupError: 'خطأ في إعداد 2FA',
        twoFAEnabled: 'تم تفعيل 2FA بنجاح!',
        twoFAVerifyError: 'رمز التحقق غير صالح',
        twoFADisabled: 'تم تعطيل 2FA',
        twoFADisableError: 'خطأ في تعطيل 2FA',
        pgpRequiredFields: 'الاسم والبريد الإلكتروني وعبارة المرور مطلوبة',
        pgpKeyCreated: 'تم إنشاء مفتاح PGP بنجاح',
        pgpKeyCreateError: 'خطأ في إنشاء المفتاح',
        pgpPublicKeyImported: 'تم استيراد المفتاح العام',
        pgpImportError: 'خطأ في استيراد المفتاح',
        pgpDeleteConfirm: 'هل تريد حذف هذا المفتاح؟',
        pgpKeyDeleted: 'تم حذف المفتاح',
        deleteError: 'خطأ في الحذف',
        delegationAdded: 'تمت إضافة صلاحية الإرسال',
        delegationAddError: 'خطأ في إضافة الصلاحية',
        delegationRemoved: 'تمت إزالة الصلاحية',
        delegationRemoveError: 'خطأ في إزالة الصلاحية',
        defaultVacationSubject: 'أنا غير متاح حاليًا',
        vacationActivated: 'تم تفعيل الرد التلقائي',
        vacationDeactivated: 'تم إيقاف الرد التلقائي',
        vacationSaveError: 'خطأ في حفظ الرد التلقائي',
        ruleNameRequired: 'اسم القاعدة مطلوب',
        ruleSaved: 'تم حفظ القاعدة',
        ruleSaveError: 'خطأ في حفظ القاعدة',
        ruleDeleted: 'تم حذف القاعدة',
        ruleDeleteError: 'خطأ في حذف القاعدة',
        labelSaved: 'تم حفظ التسمية',
        labelSaveError: 'خطأ في حفظ التسمية',
        labelDeleted: 'تم حذف التسمية',
        labelDeleteError: 'خطأ في حذف التسمية',
        scheduledCancelled: 'تم إلغاء الإرسال المجدول',
        cancelError: 'خطأ في الإلغاء',
        sessionTerminated: 'تم إنهاء الجلسة',
        sessionTerminateError: 'خطأ في قطع الاتصال',
        allSessionsTerminated: 'تم إنهاء جميع الجلسات الأخرى',
        aliasEmailRequired: 'عنوان الاسم المستعار مطلوب',
        aliasUpdated: 'تم تحديث الاسم المستعار',
        aliasAdded: 'تمت إضافة الاسم المستعار',
        aliasDeleteConfirm: 'هل تريد حذف هذا الاسم المستعار؟',
        aliasDeleted: 'تم حذف الاسم المستعار',
        mailboxShared: 'تمت مشاركة صندوق البريد بنجاح',
        revokeShareConfirm: 'هل تريد إلغاء المشاركة؟',
        selectMailboxError: 'يرجى اختيار صندوق بريد من القائمة. إذا لم يتوفر أي صندوق، اربط واحدًا من صفحة بريد الويب.',
        autoReplyAIEnabled: 'تم تفعيل الرد التلقائي بالـ AI!',
        autoReplyConfigSaved: 'تم حفظ إعدادات الرد التلقائي',
        docUploadedSuccess: 'تم الرفع بنجاح',
        uploadError: 'خطأ في الرفع',
        deleteDocConfirm: 'هل تريد حذف هذا المستند من قاعدة المعرفة؟',
        docDeleted: 'تم حذف المستند',
        contactExcluded: 'تم استثناء جهة الاتصال',
        exclusionRemoved: 'تمت إزالة الاستثناء',
        contactsImported: 'تم استيراد جهات الاتصال',
        contactsImportError: 'خطأ في استيراد جهات الاتصال',
        contactsImportedVcard: 'تم استيراد جهات الاتصال من vCard',
        vcardImportError: 'خطأ في استيراد vCard',
        backupStarted: 'بدأ تنزيل النسخة الاحتياطية...',
        backupCodesCopied: 'تم نسخ رموز النسخ الاحتياطي',
        secretCopied: 'تم نسخ الرمز السري',
        aiEngineTitle: 'محرك AI',
        aiEngineDesc: 'اختر محرك AI المفضل لديك للكتابة والردود والرد التلقائي.',
        defaultModelRecommended: 'النموذج الافتراضي (موصى به)',
        saveAiPreferences: 'حفظ تفضيلات AI',
        globalPromptTitle: 'موجّه النظام (عام)',
        globalPromptDesc: 'حدّد موجّهًا عامًا لجميع عمليات AI: كتابة الرسائل، الردود، والرد التلقائي. صِف عملك ونبرتك وتعليماتك الخاصة.',
        globalPromptPlaceholder: 'مثال: أنا مستشار أعمال، نبرتي احترافية لكنها ودودة. خاطب دائمًا بالاسم الأول. اختم بـ \'مع أطيب التحيات، [اسمي]\'. لا تعِد بأشياء لا أستطيع الوفاء بها.',
        composePromptTitle: 'موجّه مخصص لكتابة رسائل جديدة',
        composePromptPlaceholder: 'تعليمات إضافية لكتابة رسائل جديدة (فارغ = استخدام الموجّه العام)',
        replyPromptTitle: 'موجّه مخصص لردود AI',
        replyPromptPlaceholder: 'تعليمات إضافية للرد على الرسائل (فارغ = استخدام الموجّه العام)',
        autoReplyPromptTitle: 'موجّه مخصص للرد التلقائي',
        autoReplyPromptPlaceholder: 'تعليمات إضافية للرد التلقائي (فارغ = استخدام الموجّه العام)',
        savePromptSettings: 'حفظ إعدادات الموجّه',
        aiUsageAndBilling: 'استخدام AI والفوترة',
        runsPerMonth: 'تشغيلة شهريًا',
        autoTopup: 'شحن تلقائي (Top-Up) عند نفاد التشغيلات',
        runsToAdd: 'عدد التشغيلات المضافة:',
        runs: 'تشغيلات',
        recentUsage: 'الاستخدام الأخير (30 يومًا):',
        dateColumn: 'التاريخ',
        actionColumn: 'الإجراء',
        providerColumn: 'المزوّد',
        quantityColumn: 'الكمية',
        featureCompose: 'كتابة',
        featureReply: 'رد',
        featureAutoReply: 'رد تلقائي',
        storageQuotaTitle: 'حصة التخزين',
        inUse: 'قيد الاستخدام',
        allowed: 'مسموح به',
        storageUsedPercent: 'من مساحة التخزين المستخدمة',
        accountsCount: 'حسابات',
        contactsCountLabel: 'جهات اتصال',
        templatesCountLabel: 'قوالب',
        signaturesCountLabel: 'توقيعات',
        emailSignatures: 'توقيعات البريد الإلكتروني',
        noSignaturesDesc: 'لا توجد توقيعات. أنشئ توقيعًا يُضاف تلقائيًا إلى رسائلك.',
        defaultLabel: 'افتراضي',
        mailHandlerTitle: 'تطبيق البريد الافتراضي',
        mailHandlerDesc: 'اجعل Email Lion المعالج الافتراضي لروابط mailto: على هذا الجهاز. النقر على عنوان بريد إلكتروني في أي مكان سيفتح نافذة الإنشاء هنا.',
        mailHandlerButton: 'تعيين كافتراضي',
        mailHandlerInstalled: 'مسجّل في المتصفح ✓',
        mailHandlerSuccess: 'تم إرسال الطلب إلى متصفحك. وافق على الرسالة الظاهرة أعلاه للتفعيل.',
        mailHandlerError: 'رفض متصفحك الطلب. ربما تمت الموافقة عليه بالفعل، أو أن الإجراء يتطلب HTTPS.',
        mailHandlerNotSupported: 'هذا المتصفح لا يوفّر واجهة API للتسجيل التلقائي لبروتوكول mailto:. إذا كان التطبيق مثبّتًا بالفعل، فمن المفترض أن يعرضه نظام التشغيل تلقائيًا. وإلا، افتح الصفحة في Chrome / Edge / Firefox.',
        mailHandlerHttpsRequired: 'يتطلب تسجيل المعالج اتصالًا آمنًا (HTTPS). افتح الصفحة على https://emaillion.net.',
        mailHandlerStandaloneTitle: 'التطبيق مثبّت ويعمل ✓',
        mailHandlerStandaloneDesc: 'نظرًا لأن التطبيق مثبّت، يتحكم نظام التشغيل في كيفية توجيه روابط mailto:. لجعله الافتراضي: انقر زر الاختبار أدناه، أو انقر أي رابط mailto: خارج هذا التطبيق. سيعرض نظام التشغيل قائمة تطبيقات — اختر Email Lion وحدد "دائمًا".',
        mailHandlerTestTitle: '🔗 اختبار',
        mailHandlerTestDesc: 'النقر على هذا الزر يفتح رابط mailto: تجريبيًا. إذا كان كل شيء مضبوطًا بشكل صحيح، ستُفتح نافذة إنشاء هنا في Email Lion. وإلا سيعرض نظام التشغيل قائمة التطبيقات.',
        mailHandlerTestButton: 'افتح رابط mailto: تجريبيًا',
        mailHandlerAndroidHint: 'أندرويد: بعد تثبيت تطبيق PWA، انقر على أي رابط mailto: في تطبيق آخر (متصفح، WhatsApp، إلخ). سيعرض أندرويد "فتح باستخدام" — اختر Email Lion واضغط "دائمًا". للتغيير لاحقًا: إعدادات النظام ➤ التطبيقات ➤ التطبيقات الافتراضية ➤ تطبيق البريد.',
        mailHandlerIosHint: 'iOS: لا تسمح Apple لتطبيقات PWA باستبدال تطبيق البريد الافتراضي. استخدم Email Lion عبر المتصفح أو من الشاشة الرئيسية.',
        mailHandlerDesktopHint: 'سطح المكتب: النقر على "تعيين كافتراضي" يسجّل Email Lion في متصفحك. لتعيينه كافتراضي على مستوى نظام التشغيل (Windows): الإعدادات ➤ التطبيقات ➤ التطبيقات الافتراضية ➤ البريد.',
        emailTemplates: 'قوالب البريد الإلكتروني',
        newTemplate: 'قالب جديد',
        noTemplatesDesc: 'لا توجد قوالب. أنشئ قوالب للردود السريعة.',
        subjectPrefix: 'الموضوع:',
        noSubject: 'بدون موضوع',
        exportCsv: 'تصدير CSV',
        importCsv: 'استيراد CSV',
        exportVcard: 'تصدير vCard (.vcf) - متوافق مع Google / Apple / Outlook',
        importVcard: 'استيراد vCard (.vcf) - من Google / Apple / Outlook',
        searchPlaceholder: 'بحث...',
        addButton: 'إضافة',
        contactsSavedAuto: 'تُحفظ جهات الاتصال تلقائيًا عند إرسال الرسائل. يمكنك أيضًا الإضافة يدويًا.',
        importExportContacts: 'استيراد/تصدير جهات الاتصال',
        csvDescription: 'التصدير والاستيراد بصيغة جدولية (Excel, Google Sheets)',
        vcardDescription: 'الصيغة القياسية لجهات الاتصال. متوافقة مع Google Contacts وApple وOutlook',
        gmailMigrationHint: 'تنتقل من Gmail؟ انتقل إلى ',
        gmailMigrationHint2: ' > تصدير > اختر vCard > استورد الملف هنا',
        vacationActiveAlert: 'الرد التلقائي مفعّل - كل من يرسل إليك بريدًا إلكترونيًا سيتلقى ردًا تلقائيًا.',
        messageSubject: 'موضوع الرسالة',
        vacationPlaceholder: 'مرحبًا، أنا غير متاح حاليًا. سأعاود التواصل معك قريبًا...',
        fromDate: 'من تاريخ',
        toDate: 'حتى تاريخ',
        sendToContactsOnly: 'الإرسال فقط إلى جهات اتصالي',
        saveAndActivate: 'حفظ وتفعيل',
        saveDisabled: 'حفظ (معطّل)',
        rulesAndFilters: 'القواعد وعوامل التصفية',
        rulesDescription: 'تتيح لك القواعد فرز الرسائل أو تمييزها أو حذفها تلقائيًا بناءً على الشروط التي تحددها.',
        newRule: 'قاعدة جديدة',
        noRulesDesc: 'لا توجد قواعد. أنشئ قاعدة جديدة لفرز الرسائل تلقائيًا.',
        ruleDisabled: 'معطّلة',
        contactsManagement: 'إدارة جهات الاتصال',
        contactsManagementDesc: 'إدارة جهات الاتصال واستيرادها وتصديرها. اختر تبويب "عام" للتحرير الكامل.',
        goToGeneralSettings: 'انتقل إلى الإعدادات العامة لإدارة جهات الاتصال',
        minChars: '6 أحرف على الأقل',
        confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
        changePasswordBtn: 'تغيير كلمة المرور',
        twoFactorDesc: 'أضف طبقة أمان إضافية باستخدام تطبيق مصادقة مثل Google Authenticator.',
        twoFactorActive: 'المصادقة الثنائية مفعّلة ونشطة',
        backupCodesTitle: 'رموز النسخ الاحتياطي (احفظها في مكان آمن!):',
        copyAll: 'نسخ الكل',
        disablePassword: 'كلمة المرور للتعطيل',
        disable2FABtn: 'تعطيل 2FA',
        scanQrCode: 'امسح الرمز في تطبيق المصادقة، أو أدخل الرمز السري يدويًا.',
        scanWithAuthenticator: 'امسح باستخدام Google Authenticator',
        secretManualEntry: 'الرمز السري (للإدخال اليدوي)',
        enterCodeFromApp: 'أدخل الرمز من التطبيق',
        verifyAndEnable: 'تحقق وفعّل',
        enableTwoFactor: 'تفعيل المصادقة الثنائية',
        delegationTitle: 'تفويض الإرسال',
        delegationDesc: 'اسمح لمستخدمين آخرين بإرسال رسائل نيابةً عنك. سيتمكنون من اختيار عنوانك كمرسل عند كتابة رسالة.',
        delegateEmailLabel: 'بريد المستخدم الإلكتروني',
        sendAs: 'الإرسال باسم',
        sendOnBehalf: 'الإرسال بالنيابة',
        noDelegations: 'لا توجد صلاحيات إرسال نشطة',
        pgpTitle: 'تشفير البريد الإلكتروني (PGP)',
        pgpDesc: 'إدارة مفاتيح PGP لتشفير البريد الإلكتروني والتوقيعات الرقمية. أنشئ مفاتيح جديدة أو استورد المفاتيح العامة لجهات الاتصال.',
        createNewKey: 'إنشاء مفتاح جديد',
        pgpPassphrase: 'عبارة مرور التشفير',
        pgpPassphraseHelper: 'تذكّر كلمة المرور هذه - ستحتاجها للتوقيع وفك التشفير',
        createKey: 'إنشاء مفتاح',
        importPublicKey: 'استيراد مفتاح عام:',
        importKey: 'استيراد مفتاح',
        privateAndPublic: 'خاص+عام',
        publicKey: 'عام',
        fingerprint: 'البصمة',
        noPgpKeys: 'لا توجد مفاتيح PGP معدّة',
        labelsTitle: 'التسميات',
        addLabelBtn: 'إضافة تسمية',
        noLabelsAlert: 'لم يتم إنشاء تسميات بعد. تتيح لك التسميات تصنيف الرسائل بالألوان.',
        editLabelTitle: 'تعديل التسمية',
        newLabelTitle: 'تسمية جديدة',
        labelNameField: 'اسم التسمية',
        colorLabel: 'اللون:',
        preview: 'معاينة',
        scheduledEmails: 'الرسائل المجدولة',
        refreshBtn: 'تحديث',
        noScheduledEmails: 'لا توجد رسائل مجدولة. يمكنك جدولة الرسائل من نافذة الرسالة الجديدة.',
        recipient: 'المستلم',
        scheduledFor: 'مجدولة في',
        statusPending: 'قيد الانتظار',
        statusSent: 'أُرسلت',
        statusCancelled: 'أُلغيت',
        statusFailed: 'فشلت',
        cancelSend: 'إلغاء الإرسال',
        noSubjectLabel: '(بدون موضوع)',
        aiAutoReplyTitle: 'الرد التلقائي الذكي بالـ AI',
        active: 'نشط',
        inactive: 'غير نشط',
        selectMailbox: 'اختر صندوق بريد لتفعيل الرد التلقائي:',
        noMailboxes: 'لا توجد صناديق بريد متصلة. اربط صندوق بريد من صفحة بريد الويب لتفعيل الرد التلقائي.',
        betaInfo: 'سيرد الرد التلقائي على الرسائل الواردة بناءً على الموجّه وقاعدة المعرفة الخاصة بك. الرسائل الحقيقية فقط - ليس الرسائل المزعجة أو الإعلانات أو النشرات البريدية.',
        activeMailbox: 'صندوق البريد النشط:',
        promptSetup: 'الموجّه والإعداد',
        promptSetupDesc: 'حدّد من أنت، وما عملك، وكيف تريد الرد. كلما كانت التفاصيل أدق، كانت الردود أفضل.',
        toneLabel: 'النبرة',
        toneProfessional: 'احترافية',
        toneFriendly: 'ودّية',
        toneBrief: 'مختصرة',
        toneFormal: 'رسمية',
        languageLabel: 'اللغة',
        hebrew: 'العبرية',
        maxLengthWords: 'الطول الأقصى (كلمات)',
        delayMinutes: 'التأخير (دقائق)',
        knowledgeBase: 'قاعدة المعرفة',
        documentsCount: 'مستندات',
        knowledgeBaseDesc: 'ارفع مستندات ليستخدمها AI في تقديم ردود دقيقة. الصيغ المدعومة: TXT, CSV, JSON, HTML, MD.',
        uploadDocument: 'رفع مستند',
        maxDocSize: 'بحد أقصى 50KB لكل مستند',
        noDocuments: 'لا توجد مستندات. ارفع مستندات للحصول على ردود AI أكثر دقة.',
        emailFiltering: 'تصفية الرسائل',
        skipSpam: 'تخطي الرسائل المزعجة',
        skipPromotions: 'تخطي العروض الترويجية',
        skipNewsletters: 'تخطي النشرات البريدية',
        skipNoreply: 'تخطي عناوين no-reply',
        skipAutoReplies: 'تخطي الردود التلقائية',
        onlyKnownContacts: 'الرد فقط على جهات الاتصال المعروفة',
        startHour: 'ساعة البداية',
        endHour: 'ساعة النهاية',
        activeDays: 'الأيام النشطة',
        maxRepliesPerDay: 'الحد الأقصى للردود يوميًا',
        maxRepliesPerSender: 'الحد الأقصى لكل مرسل',
        exclusionsTitle: 'الاستثناءات',
        exclusionsDesc: 'جهات الاتصال التي لن تتلقى ردودًا تلقائية - سترد عليها يدويًا.',
        exclusionName: 'الاسم (اختياري)',
        exclusionReason: 'السبب',
        replyLog: 'سجل الردود',
        sentCount: 'أُرسلت',
        skippedCount: 'تم تخطيها',
        failedCount: 'فشلت',
        excludedCount: 'مستثناة',
        avgTime: 'متوسط الوقت',
        noLogEntries: 'لا توجد سجلات بعد.',
        senderColumn: 'المرسل',
        reasonResponseColumn: 'السبب / الرد',
        logStatusSent: 'أُرسلت',
        logStatusSkipped: 'تم التخطي',
        logStatusExcluded: 'مستثناة',
        logStatusFailed: 'فشلت',
        saving: 'جارٍ الحفظ...',
        saveAutoReplySettings: 'حفظ إعدادات الرد التلقائي',
        backupExport: 'نسخ احتياطي وتصدير صندوق البريد',
        backupDesc: 'نزّل جميع الرسائل من المجلد المحدد كملف ZIP. تُحفظ كل رسالة بصيغة ‎.eml.',
        inboxFolder: 'الوارد',
        sentFolder: 'البريد المرسل',
        draftsFolder: 'المسودات',
        trashFolder: 'المهملات',
        spamFolder: 'الرسائل المزعجة',
        downloadBackup: 'تنزيل النسخة الاحتياطية (ZIP)',
        aliasAddresses: 'عناوين الأسماء المستعارة',
        addAlias: 'إضافة اسم مستعار',
        noAliases: 'لم يتم إعداد أسماء مستعارة. أضف عناوين لإرسال الرسائل منها.',
        noDisplayName: 'بدون اسم عرض',
        sharedMailboxes: 'صناديق البريد المشتركة',
        shareMailbox: 'مشاركة صندوق البريد',
        sharedWithMe: 'تمت مشاركتها معي:',
        myShares: 'مشاركاتي:',
        permissionRead: 'قراءة',
        permissionWrite: 'كتابة',
        permissionAdmin: 'مسؤول',
        sharedWith: 'تمت مشاركتها مع:',
        permissionLabel: 'الصلاحية:',
        noSharedMailboxes: 'لا توجد صناديق بريد مشتركة. انقر "مشاركة صندوق البريد" للمشاركة مع أعضاء الفريق.',
        shareMailboxDialog: 'مشاركة صندوق البريد',
        shareMailboxDesc: 'اختر صندوق البريد الذي تريد مشاركته والمستخدم الذي تريد المشاركة معه.',
        mailboxToShare: 'صندوق البريد للمشاركة',
        noConnectedMailboxes: 'لا توجد صناديق بريد متصلة',
        shareWithUser: 'المشاركة مع مستخدم',
        searchUserPlaceholder: 'ابحث عن مستخدم بالاسم أو البريد الإلكتروني...',
        noUsersFound: 'لم يتم العثور على مستخدمين',
        loadingUsers: 'جارٍ تحميل المستخدمين...',
        noName: 'بدون اسم',
        adminRole: 'مسؤول',
        userRole: 'مستخدم',
        permissionLevel: 'مستوى الصلاحية',
        readOnlyDesc: 'قراءة فقط - عرض الرسائل',
        readWriteDesc: 'قراءة + كتابة - إرسال الرسائل',
        fullAdminDesc: 'مسؤول كامل - يشمل الإعدادات',
        shareBtn: 'مشاركة',
        activeSessions: 'الجلسات النشطة',
        disconnectAll: 'قطع اتصال الكل',
        noSessions: 'لا توجد جلسات نشطة مسجّلة.',
        deviceBrowser: 'الجهاز / المتصفح',
        ipAddress: 'عنوان IP',
        lastActivity: 'آخر نشاط',
        createdColumn: 'تاريخ الإنشاء',
        unknown: 'غير معروف',
        disconnectSession: 'قطع اتصال الجلسة',
        editAliasTitle: 'تعديل الاسم المستعار',
        newAliasTitle: 'إضافة اسم مستعار جديد',
        aliasEmailField: 'عنوان البريد الإلكتروني',
        displayNameField: 'اسم العرض',
        displayNamePlaceholder: 'الاسم الظاهر للمستلمين',
        setAsDefault: 'تعيين كعنوان افتراضي',
        ruleIfPrefix: 'إذا',
        conditionFrom: 'من',
        conditionTo: 'إلى',
        conditionSubject: 'الموضوع',
        conditionHasAttachment: 'يحتوي على مرفق',
        conditionContains: 'يحتوي على',
        conditionEquals: 'يساوي',
        conditionStartsWith: 'يبدأ بـ',
        conditionEndsWith: 'ينتهي بـ',
        conditionYes: 'نعم',
        actionMoveToFolder: 'نقل إلى مجلد',
        actionMarkRead: 'وضع علامة كمقروء',
        actionStar: 'إضافة نجمة',
        actionDelete: 'حذف',
        actionForward: 'إعادة توجيه إلى عنوان',
        valuePlaceholder: 'القيمة...',
        folderNamePlaceholder: 'اسم المجلد (مثلًا: Spam, Archive)',
        forwardPlaceholder: 'عنوان إعادة التوجيه',
        ruleActive: 'القاعدة نشطة',
        conditionLabel: 'الشرط',
        actionLabel: 'الإجراء',
        sigDialogPlaceholder: 'اكتب توقيعك هنا...',
        templateContentPlaceholder: 'اكتب محتوى القالب...',
        category: 'الفئة',
        subjectOptional: 'الموضوع (اختياري)',
        notesLabel: 'ملاحظات',
        newContactTitle: 'جهة اتصال جديدة',
        popupView: 'نافذة منبثقة',
        popupViewDesc: 'النقر على رسالة يفتح مربع حوار.',
        pageView: 'صفحة منفصلة (Gmail)',
        pageViewDesc: 'النقر على رسالة يفتح صفحة كاملة.',
        previewView: 'جزء المعاينة (Outlook)',
        previewViewDesc: 'النقر يعرض معاينة على الجانب.',
        recommended: 'موصى به',
        fast: 'سريع',
        dayNamesShort: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
        betaModePrefix: 'وضع BETA:',
        webmailPage: 'بريد الويب',
        promptExample: 'مثال:\nأنا يوسي، المدير التنفيذي لشركة Emilion. نحن شركة تطوير وتصميم مواقع ويب.\n\nالأسعار:\n- صفحة هبوط: 800-2,200 دولار\n- متجر إلكتروني: 2,200-4,000 دولار\n- تطبيق: ابتداءً من 5,500 دولار\n\nيرجى الرد على أسئلة العملاء باحترافية ولطف.',
        dangerZone: 'منطقة الخطر',
        deleteAccountTitle: 'حذف الحساب',
        deleteAccountDesc: 'حذف حسابك إجراء لا رجعة فيه. ستُوضع علامة "محذوف" على جميع بياناتك وسيتم تسجيل خروجك.',
        deleteAccountBtn: 'حذف الحساب',
        deleteIrreversible: 'هذا الإجراء لا رجعة فيه على الإطلاق. سيُوضع على حسابك علامة "محذوف" ولن تتمكن من تسجيل الدخول مرة أخرى.',
        deleteConfirmQuestion: 'هل أنت متأكد أنك تريد حذف حسابك؟',
        deleteAfterInfo: 'بعد الحذف سيتم تسجيل خروجك تلقائيًا. وسيتم إخطار مسؤول النظام.',
        deleteTypeToConfirm: 'للتأكيد، اكتب في الحقل أدناه:',
        deleteTypeLabel: 'اكتب للتأكيد',
        deleteContinue: 'متابعة',
        deleteInProgress: 'جارٍ الحذف...',
        deleteConfirmBtn: 'تأكيد الحذف',
        deleteAccountError: 'خطأ في حذف الحساب',
        connectionTestSubject: 'اختبار اتصال Email Lion',
        connectionTestBody: 'إذا فُتحت هذه النافذة في Email Lion — فالإعداد يعمل.',
    },

    // ==================== DASHBOARD PAGE ====================
    dashboard: {
        title: 'لوحة التحكم',
        greeting: 'مرحبًا',
        dateLocale: 'ar',
        organizations: 'المؤسسات',
        activeMailboxes: 'صناديق البريد النشطة',
        domains: 'النطاقات',
        storageUsed: 'مساحة التخزين المستخدمة',
        activityTrend: 'النشاط – آخر 7 أيام',
        activityByType: 'النشاط حسب النوع (30 يومًا)',
        storageByOrg: 'التخزين حسب المؤسسة',
        usersByRole: 'المستخدمون حسب الدور',
        mailboxStatus: 'حالة صناديق البريد',
        recentActivity: 'النشاط الأخير',
        noData: 'لا توجد بيانات',
        noDataYet: 'لا توجد بيانات بعد',
        noDataToShow: 'لا توجد بيانات للعرض',
        system: 'النظام',
        storageUsedLabel: 'المستخدم',
        storageQuotaLabel: 'الحصة',
        connectedAccounts: 'متصلة',
        hostedMailboxes: 'مستضافة',
        totalMailboxes: 'من إجمالي {{total}}',
        verifiedDomains: 'موثّقة',
        actionsLabel: 'إجراءات',
        roles: {
            super_admin: 'المسؤول الأعلى',
            org_admin: 'مسؤول المؤسسة',
            multi_org_admin: 'مسؤول عدة مؤسسات',
            user: 'مستخدم',
        },
        actions: {
            login: 'تسجيل الدخول',
            send_email: 'إرسال بريد إلكتروني',
            create_user: 'إنشاء مستخدم',
            update_user: 'تحديث مستخدم',
            delete_user: 'حذف مستخدم',
            create_org: 'إنشاء مؤسسة',
            create_domain: 'إنشاء نطاق',
            create_mailbox: 'إنشاء صندوق بريد',
        },
    },

    // ==================== MODULES / TRIAL ====================
    modules: {
        automations: {
            title: 'أتمتة البريد الإلكتروني بالذكاء الاصطناعي',
            tagline: 'حلّل الرسائل الواردة، واستخرج البيانات من الملفات، وأنشئ المهام تلقائيًا.',
            bullets: [
                'AI يلخّص ويصنّف ويرد على كل رسالة ذات صلة',
                'التقرير اليومي المجدول يشمل المهام والرسائل وتنبيهات التقويم',
                'استخراج المرفقات وإرسالها إلى Drive/Dropbox مع أرشفة ذكية',
            ],
            trialDescription: 'خلال الفترة التجريبية يمكنك إنشاء أتمتة واحدة وتشغيلها حتى 10 مرات.',
            gentleNudge: 'ابدأ بأتمتة واحدة على رسالة حقيقية. بمجرد أن ترى النتائج، تفتح الترقية المزيد من الأتمتات والتشغيل المستمر.',
            primaryCta: 'الترقية إلى الأتمتة الكاملة',
            secondaryCta: 'اربط صندوق بريد أولًا',
        },
        ai_agent: {
            title: 'وكيل AI الشخصي',
            tagline: 'محادثة حرة مع AI يعرف صندوق بريدك وتقويمك ومهامك.',
            bullets: [
                'اسأل بلغة طبيعية، واحصل على إجراءات منفّذة (إرسال، تصنيف، أرشفة)',
                'يتصل بـ Green Invoice، ويعثر على الفواتير، ويلخّص الرسائل',
                'يحتفظ بذاكرة شخصية وقوالب موجّهات تصممها بنفسك',
            ],
            trialDescription: 'خلال الفترة التجريبية تحصل على 10 محادثات مجانية.',
            gentleNudge: 'جرّب السؤال عن رسائلك أو تقويمك أو أتمتاتك. لا تُخصم أي أرصدة خلال الفترة التجريبية؛ وبعدها تواصل مع باقة أرصدة.',
            primaryCta: 'شراء أرصدة',
            secondaryCta: 'اربط صندوق بريد للحصول على إجابات أفضل',
        },
        filing: {
            title: 'أرشفة المستندات الذكية',
            tagline: 'كل مستند يصل عبر البريد الإلكتروني يُؤرشف تلقائيًا في المجلد الصحيح في Drive أو Dropbox.',
            bullets: [
                'AI يتعرف على نوع المستند (فاتورة / عقد / إيصال) ويؤرشفه تلقائيًا',
                'اتصال OAuth آمن بـ Google Drive وDropbox',
                'قواعد أرشفة مخصصة — حسب المرسل والكلمات المفتاحية والمحتوى',
            ],
            trialDescription: 'خلال الفترة التجريبية يمكنك إنشاء قاعدة واحدة وأرشفة حتى 10 مستندات.',
            gentleNudge: 'يمكنك إنشاء اتصال سحابة وقاعدة أولى للتجربة. بعد بضع عمليات أرشفة ناجحة، تفتح الباقة الكاملة الأرشفة المستمرة.',
            primaryCta: 'الترقية إلى الأرشفة الكاملة',
            secondaryCta: 'أنشئ قاعدتك الأولى',
        },
        proposals: {
            title: 'نظام عروض الأسعار',
            tagline: 'عروض أسعار بتصميم احترافي، وموافقة عبر الإنترنت وتوقيع رقمي — حتى على الهاتف المحمول.',
            bullets: [
                'إنشاء سريع من قالب، وحساب تلقائي لضريبة القيمة المضافة والخصومات',
                'يوافق العميل ويوقّع عبر الإنترنت — لا مزيد من ملفات PDF لإعادتها بالبريد',
                'تحصيل دفعة أولى مدمج، مع إيصال',
            ],
            trialDescription: 'خلال الفترة التجريبية يمكنك إنشاء حتى 10 عروض أسعار.',
            gentleNudge: 'أنشئ بضعة عروض حقيقية وشاهد كيف يوافق العملاء عبر الإنترنت. بعد الفترة التجريبية، واصل مع باقة أو وحدة عروض الأسعار.',
            primaryCta: 'الترقية إلى عروض أسعار غير محدودة',
            secondaryCta: 'أنشئ عرض سعر تجريبيًا',
        },
        trialEnded: 'انتهت الفترة التجريبية — قم بالترقية',
        trialMode: 'الوضع التجريبي',
        trialRemaining: 'التجربة: تبقّى {remaining}/{max}',
        trialAlertText: 'في الوضع التجريبي — تبقّى لديك {remaining} من {max} استخدامات.',
        upgradeBtn: 'ترقية',
        moduleFallback: 'وحدة',
        viewOnlyMode: 'وضع العرض فقط',
        upgradeNow: 'قم بالترقية الآن للوصول الكامل',
        getQuote: 'احصل على عرض سعر',
        capReachedTitle: 'وصلت إلى حد الفترة التجريبية',
        trialEndedTitle: 'انتهت الفترة التجريبية',
        trialExhaustedMsg: 'لقد استنفدت رصيد الفترة التجريبية لهذه الوحدة. قم بالترقية للحصول على وصول كامل وفتح جميع الإمكانيات.',
        trialAutomationCapMsg: 'في الوضع التجريبي يمكنك إنشاء أتمتة واحدة فقط. الترقية تفتح أتمتات غير محدودة.',
        trialRuleCapMsg: 'في الوضع التجريبي يمكنك إنشاء قاعدة واحدة فقط. الترقية تفتح قواعد غير محدودة.',
        upgradeNowBtn: 'قم بالترقية الآن',
    },

    // ==================== UPGRADE PROMPT ====================
    upgrade: {
        upgradePlan: 'ترقية الباقة',
        choosePlan: 'اختر باقة',
        perMailbox: '/صندوق بريد',
        mailboxCount: 'عدد صناديق البريد:',
        billingCycle: 'دورة الفوترة',
        monthly: 'شهري',
        yearly: 'سنوي',
        perMonthShort: '/شهر',
        yearlySavings: '(وفّر 20%)',
        platformFee: 'رسوم المنصة',
        mailboxes: 'صناديق بريد',
        volumeDiscount: 'خصم الكمية ({percent}%)',
        vat: 'ضريبة القيمة المضافة (18%)',
        totalYearlyVat: 'الإجمالي السنوي شامل الضريبة',
        totalMonthlyVat: 'الإجمالي الشهري شامل الضريبة',
        perMonthOnly: '= ₪{amount} شهريًا فقط (شامل الضريبة)',
        payNow: 'ادفع الآن',
        paymentTitle: 'الدفع',
        preparingPayment: 'جارٍ تجهيز صفحة الدفع...',
        paymentFailed: 'فشل الدفع. يرجى المحاولة مرة أخرى.',
        noPaymentLink: 'لم يتم استلام رابط دفع',
        paymentError: 'خطأ في إنشاء الدفع',
        freePlanBanner: 'أنت على الباقة المجانية — قم بالترقية إلى باقة مدفوعة للحصول على المزيد من صناديق البريد والتخزين والوحدات الكاملة',
        nearLimitBanner: 'لقد وصلت إلى {percent}% من حصتك — قم بالترقية لتجنب الحظر',
        upgradeNow: 'قم بالترقية الآن',
        getQuote: 'احصل على عرض سعر',
        getDetailedQuote: 'احصل على عرض سعر مفصّل',
        upgradeToPaid: 'الترقية إلى باقة مدفوعة',
        nearPlanLimit: 'قريب من حد الباقة',
        mailboxesUsage: 'صناديق البريد: {used}/{max} ({percent}%)',
        storageUsage: 'التخزين: {used} GB / {max} GB ({percent}%)',
    },

    // ==================== ATTACHMENTS ====================
    attachments: {
        attachedFiles: 'المرفقات',
        file: 'ملف',
        clickToView: 'انقر للعرض',
        clickToDownload: 'انقر للتنزيل',
        download: 'تنزيل',
        downloadError: 'خطأ في تنزيل الملف',
        loadError: 'خطأ في تحميل الملف',
        cannotLoadFile: 'تعذّر تحميل الملف',
        tryDownload: 'حاول التنزيل',
        downloadFile: 'نزّل الملف',
        downloadFileShort: 'تنزيل الملف',
        loadingFile: 'جارٍ تحميل الملف...',
        loadingEditView: 'جارٍ تحميل عرض التحرير...',
        loading: 'جارٍ التحميل...',
        pdfRenderError: 'تعذّر تحميل معاينة PDF. يمكنك الرسم على الخلفية البيضاء — ستُحفظ التوقيعات في الملف.',
        pdfNotSupported: 'متصفحك لا يدعم عرض PDF المضمّن',
        ofTotal: 'من',
        finishEditing: 'إنهاء التحرير',
        editAnnotate: 'تحرير / إضافة تعليقات',
        signature: 'التوقيع',
        saveSignedPdf: 'حفظ PDF الموقّع',
        print: 'طباعة',
        replyWithFile: 'الرد مع الملف',
        drawTool: 'أداة الرسم',
        draw: 'رسم',
        addText: 'إضافة نص',
        text: 'نص',
        handTool: 'أداة اليد (سحب التوقيع)',
        move: 'تحريك',
        undoLast: 'التراجع عن الأخير',
        clearAll: 'مسح الكل',
        eSignature: 'التوقيع الإلكتروني',
        drawSignatureTab: 'رسم توقيع',
        savedSignaturesTab: 'التوقيعات المحفوظة',
        uploadImageTab: 'رفع صورة',
        drawSignatureHint: 'ارسم توقيعك في الحقل أدناه. سيُحفظ كملف PNG شفاف.',
        clear: 'مسح',
        signatureNamePlaceholder: 'اسم التوقيع (اختياري)',
        saveSignatureTooltip: 'حفظ التوقيع للاستخدام المستقبلي',
        save: 'حفظ',
        noSavedSignatures: 'لا توجد توقيعات محفوظة',
        drawNewSignature: 'رسم توقيع جديد',
        signatureDefault: 'التوقيع',
        setAsDefault: 'تعيين كافتراضي',
        deleteSig: 'حذف',
        uploadSignatureImage: 'رفع صورة توقيع',
        uploadHint: 'يوصى بملف PNG شفاف. الصور الأخرى (JPG, WEBP) سيتم تحويلها تلقائيًا.',
        chooseImage: 'اختر صورة',
        imageSavedToAccount: 'ستُحفظ الصورة في حسابك لإعادة الاستخدام',
        cancel: 'إلغاء',
        placeSignatureOnDoc: 'وضع التوقيع على المستند',
        clickSigToPlace: 'انقر على توقيع لوضعه على المستند',
        drawSignatureFirst: 'يرجى رسم توقيع أولًا',
        signatureSaved: 'تم حفظ التوقيع بنجاح',
        signatureSaveError: 'خطأ في حفظ التوقيع',
        chooseImageFile: 'يرجى اختيار ملف صورة',
        imageSavedAsSignature: 'تم حفظ الصورة كتوقيع',
        imageSaveError: 'خطأ في حفظ الصورة',
        importedSignature: 'توقيع مستورد',
        signatureDeleted: 'تم حذف التوقيع',
        signatureDeleteError: 'خطأ في حذف التوقيع',
        signedFileSaved: 'تم حفظ الملف الموقّع بنجاح',
        signedFileSaveError: 'خطأ في حفظ ملف PDF المعلَّق',
        signedFileAttached: 'تم إرفاق الملف الموقّع بالرد',
        fileAttached: 'تم إرفاق الملف بالرد',
        attachError: 'خطأ في إرفاق الملف',
        noSubject: '(بدون موضوع)',
        emailFrom: 'من:',
        emailTo: 'إلى:',
        emailCc: 'نسخة:',
        emailDate: 'التاريخ:',
        emptyEmailBody: 'رسالة البريد المرفقة فارغة.',
        nestedAttachments: 'ملفات داخل الرسالة',
        csvPreviewHint: 'عرض {shown} من {total} صفوف',
        noCalendarEvents: 'لم يتم العثور على أحداث في ملف التقويم',
        untitledEvent: 'حدث بدون عنوان',
        eventWhen: 'متى',
        eventWhere: 'أين',
        noContacts: 'لم يتم العثور على جهات اتصال',
        unnamedContact: 'جهة اتصال بدون اسم',
        officeNeedsDownload: 'ملفات Word / Excel / PowerPoint تُفتح بعد التنزيل، كما في معظم تطبيقات البريد.',
        msgNeedsDownload: 'لا يمكن فتح ملفات Outlook (.msg) في المتصفح. قم بتنزيلها أو اطلب من المرسل إرسال .eml.',
    },

    // ==================== AI AGENT ====================
    aiAgent: {
        title: 'وكيل AI الشخصي',
        subtitle: 'اطرح أسئلة ونفّذ مهام على الرسائل والتقويم والأتمتة والأرشفة. الإجراءات الحساسة تنتظر الموافقة.',
        subtitleShort: 'اطرح أسئلة ونفّذ مهام على الرسائل والتقويم والأتمتة والأرشفة.',
        conversations: 'المحادثات',
        noConversations: 'لا توجد محادثات بعد',
        newConversation: 'محادثة جديدة',
        deleteConversationAria: 'حذف المحادثة',
        deleteConversationConfirm: 'هل تريد حذف هذه المحادثة من السجل؟',
        conversationDeleted: 'تم حذف المحادثة من السجل',
        errorLoadConversations: 'خطأ في تحميل محادثات الوكيل',
        errorLoadConversation: 'خطأ في تحميل المحادثة',
        errorDeleteConversation: 'خطأ في حذف المحادثة',
        errorSendMessage: 'خطأ في إرسال الرسالة إلى الوكيل',
        errorLoadGreenInvoice: 'خطأ في تحميل إعدادات Green Invoice',
        errorLoadMemories: 'خطأ في تحميل ذكريات الوكيل',
        errorLoadPending: 'خطأ في تحميل الإجراءات المعلّقة',
        errorLoadUsage: 'خطأ في تحميل تقارير الاستخدام والتكاليف',
        errorLoadBilling: 'خطأ في تحميل إعدادات الفوترة',
        greenInvoiceSaved: 'تم حفظ إعدادات Green Invoice بنجاح',
        errorSaveGreenInvoice: 'خطأ في حفظ إعدادات Green Invoice',
        connectionTestFailed: 'فشل اختبار الاتصال',
        memorySaved: 'تم حفظ الذاكرة بنجاح',
        errorSaveMemory: 'خطأ في حفظ الذاكرة',
        memoryDeleted: 'تم حذف الذاكرة',
        errorDeleteMemory: 'خطأ في حذف الذاكرة',
        billingSaved: 'تم حفظ إعدادات الفوترة',
        errorSaveBilling: 'خطأ في حفظ إعدادات الفوترة',
        errorCreatePayment: 'خطأ في إنشاء دفعة لباقة الأرصدة',
        paymentsSynced: 'تم فحص المدفوعات وتحديث رصيد الأرصدة إذا اكتمل الدفع',
        errorSyncPayments: 'خطأ في مزامنة دفعة الأرصدة',
        topupEnabled: 'تم تفعيل الشحن التلقائي Top-up. جارٍ فتح دفعة أولية لتعبئة الرصيد الآن.',
        errorSaveTopup: 'خطأ في حفظ إعدادات Top-up',
        templateNeedsNameAndText: 'يرجى إعطاء القالب اسمًا ونصًا',
        templateUpdated: 'تم تحديث القالب',
        templateSaved: 'تم حفظ القالب',
        errorSaveTemplate: 'خطأ في حفظ القالب',
        deleteTemplateConfirm: 'هل تريد حذف هذا القالب؟',
        errorDeleteTemplate: 'خطأ في حذف القالب',
        errorConfirmation: 'خطأ في معالجة التأكيد',
        doneFallback: 'تم.',
        actionApproved: 'تمت الموافقة على الإجراء وتنفيذه.',
        actionCancelled: 'تم إلغاء الإجراء ولم يُنفّذ.',
        templatesBtn: 'القوالب',
        pendingActionsBtn: 'الإجراءات المعلّقة',
        pendingActionsTooltip: 'إجراءات معلّقة ({count})',
        settingsBtn: 'الإعدادات',
        personalScopeChip: 'نطاق شخصي فقط',
        approvalChip: 'موافقة قبل إجراءات الكتابة',
        availableCredits: 'الأرصدة المتاحة: {amount}',
        greenInvoiceConnectedChip: 'Green Invoice متصل',
        questionTemplates: 'قوالب الأسئلة',
        howCanIHelp: 'كيف يمكنني المساعدة؟',
        examplesText: 'على سبيل المثال: "ابحث عن رسائل من العميل داني"، "حلّل تقويمي لهذا الأسبوع"، "زامن التقويم بالكامل من Google"، "أنشئ أتمتة لفواتير الموردين" أو "نظّم ملفاتي في Drive".',
        pendingApprovalTitle: 'إجراءات بانتظار الموافقة',
        pendingApprovalText: 'هناك {count} إجراءً من جميع محادثات الوكيل بانتظار موافقتك.',
        openApprovalBoard: 'فتح لوحة الموافقات',
        toolResult: 'نتيجة الأداة:',
        purchase: 'شراء',
        enableTopup: 'تفعيل Top-up',
        actionApprovalRequired: 'مطلوبة موافقة على الإجراء',
        toolLabel: 'الأداة:',
        approveAndRun: 'الموافقة والتنفيذ',
        cancelBtn: 'إلغاء',
        agentThinking: 'الوكيل يفكر...',
        inputPlaceholder: 'أخبر الوكيل بما تريد فعله...',
        templatesDialogTitle: 'قوالب أسئلة الوكيل',
        newTemplate: 'قالب جديد',
        templatesDialogHint: 'اختر قالبًا لنسخ نصه إلى حقل الموجّه. يمكنك أيضًا إنشاء قوالب شخصية قابلة لإعادة الاستخدام.',
        editTemplate: 'تعديل القالب',
        category: 'الفئة',
        templateName: 'اسم القالب',
        templateText: 'نص القالب',
        updateTemplate: 'تحديث القالب',
        saveTemplate: 'حفظ القالب',
        myTemplates: 'قوالبي',
        noCustomTemplates: 'لم تنشئ قوالب شخصية بعد. انقر "قالب جديد" لإضافة أول قالب.',
        editTemplateAria: 'تعديل القالب',
        deleteTemplateAria: 'حذف القالب',
        builtinTemplates: 'القوالب المدمجة',
        customCategory: 'شخصي',
        settingsTitle: 'إعدادات وكيل AI',
        tabMemories: 'الذكريات',
        tabApprovals: 'إجراءات للموافقة',
        tabUsage: 'الاستخدام والفوترة',
        tabInvoices: 'الفواتير',
        invoicesTitle: 'الفواتير',
        invoicesHint: 'أدخل بيانات اعتماد API ليتمكن الوكيل من البحث في المستندات والتقارير في Green Invoice. يُخزَّن المفتاح والرمز السري مشفّرين.',
        saveScope: 'نطاق الحفظ',
        scopeMyUserOnly: 'المستخدم الخاص بي فقط',
        scopeOrg: 'المؤسسة بأكملها',
        existingConnection: 'اتصال موجود: المفتاح {key} · الرمز السري {secret}',
        savedLabel: 'محفوظ',
        enterApiKey: 'أدخل API Key',
        enterApiSecret: 'أدخل API Secret',
        keepEmptyKey: 'اتركه فارغًا للاحتفاظ بالمفتاح الحالي.',
        keepEmptySecret: 'اتركه فارغًا للاحتفاظ بالرمز السري الحالي.',
        testConnection: 'اختبار الاتصال',
        memoriesTitle: 'إدارة الذكريات الشخصية',
        memoryType: 'النوع',
        memoryKey: 'المفتاح',
        memoryValue: 'قيمة الذاكرة',
        updateMemory: 'تحديث الذاكرة',
        addMemory: 'إضافة ذاكرة',
        cancelEdit: 'إلغاء التعديل',
        noMemories: 'لا توجد ذكريات محفوظة بعد.',
        updatedAtLabel: 'آخر تحديث',
        noPendingActions: 'لا توجد إجراءات بانتظار الموافقة حاليًا.',
        conversationLabel: 'المحادثة:',
        usageTitle: 'أرصدة AI والاستخدام والتكاليف',
        creditBalance: 'رصيد الأرصدة',
        availableOf: 'متاح {available} من {total}',
        lowBalance: 'رصيد منخفض',
        refreshCredits: 'تحديث الأرصدة',
        syncPayment: 'مزامنة الدفع',
        reportScope: 'نطاق التقرير',
        scopeMyUser: 'المستخدم الخاص بي',
        refreshReport: 'تحديث التقرير',
        requestsLabel: 'الطلبات',
        tokensLabel: 'الرموز (Tokens)',
        costLabel: 'التكلفة',
        recommendedCharge: 'الرسوم الموصى بها',
        expectedProfit: 'الربح المتوقع',
        billingSettingsTitle: 'إعدادات الفوترة والربح',
        billingScope: 'نطاق الفوترة',
        markupPercent: 'هامش الربح (%)',
        saveMarkup: 'حفظ الهامش',
        markupHint: 'تُحسب الرسوم الموصى بها من تكلفة AI الفعلية مضافًا إليها هامش الربح المحدد.',
        buyCreditsTitle: 'شراء أرصدة وكيل AI',
        syncPaymentAndUpdate: 'مزامنة الدفع وتحديث الرصيد',
        promptRoles: ['الإدارة', 'المالية', 'خدمة العملاء', 'المبيعات'],
        promptTemplates: [
            { role: 'الإدارة', label: 'ملخص يومي', prompt: 'لخّص لي ما حدث اليوم في رسائلي وتقويمي وأتمتاتي، واقترح الإجراءات الخمسة التالية حسب الأولوية.' },
            { role: 'الإدارة', label: 'تقرير حالة', prompt: 'أعِدّ تقريرًا قصيرًا عن حالة العمل هذا الأسبوع: العملاء الذين ينتظرون ردودًا، والاجتماعات القادمة، والأتمتات التي تحتاج إلى مراجعة.' },
            { role: 'الإدارة', label: 'فحص الإمكانيات', prompt: 'تحقق من الإمكانيات المتاحة لي حاليًا: الرسائل، التقويم، الأتمتة، الأرشفة واتصالات السحابة.' },
            { role: 'الإدارة', label: 'تحضير المهام', prompt: 'أعِدّ قائمة مهام متابعة من رسائلي الأخيرة، دون تنفيذ أي إجراء قبل موافقتي.' },
            { role: 'الإدارة', label: 'تحسين العمليات', prompt: 'راجع قائمة الأتمتات الخاصة بي واقترح 3 تحسينات عملية لتقليل العمل اليدوي.' },
            { role: 'المالية', label: 'فواتير في البريد', prompt: 'ابحث في رسائلي عن رسائل تتعلق بـ "فاتورة" ولخّص أهم 10 نتائج.' },
            { role: 'المالية', label: 'Green Invoice', prompt: 'ابحث في Green Invoice عن مستندات متعلقة بالعميل "داني" ولخّص رقم المستند والتاريخ والحالة والمبلغ.' },
            { role: 'المالية', label: 'مستندات مفتوحة', prompt: 'ابحث في Green Invoice عن مستندات مفتوحة أو غير مدفوعة ورتّبها حسب الأولوية.' },
            { role: 'المالية', label: 'تقرير مالي', prompt: 'أعِدّ تقريرًا قصيرًا من Green Invoice عن مستندات الشهر الماضي: كم مستندًا وُجد، وأي عملاء بارزون، وما يحتاج إلى اهتمام.' },
            { role: 'المالية', label: 'أتمتة الفواتير', prompt: 'أنشئ أتمتة جديدة تكتشف الرسائل المتعلقة بالفواتير، وتستخرج المبلغ والمورد والتاريخ، وترسل النتيجة إلى بريدي الإلكتروني. اطلب الموافقة قبل الإنشاء.' },
            { role: 'خدمة العملاء', label: 'بحث عن عميل', prompt: 'ابحث عن رسائل متعلقة بعميل يُدعى "داني" واعرض لي الموضوع والمرسل والتاريخ لكل نتيجة.' },
            { role: 'خدمة العملاء', label: 'ملخص المعالجة', prompt: 'ابحث عن رسائل تتعلق بـ "عرض سعر" ولخّص ما يحتاج إلى معالجة وما تم إغلاقه بالفعل.' },
            { role: 'خدمة العملاء', label: 'مسودة رد', prompt: 'صِغ رسالة احترافية إلى عميل تؤكد استلامنا للمستندات وأننا سنعود إليه بإجابة بحلول الغد. لا تُرسل بدون موافقتي.' },
            { role: 'خدمة العملاء', label: 'التقويم الأسبوعي', prompt: 'حلّل ولخّص لي أحداث تقويمي للأيام السبعة القادمة حسب اليوم والوقت، بما في ذلك التنبيهات/التذكيرات وأي تعارضات.' },
            { role: 'خدمة العملاء', label: 'مزامنة التقويم', prompt: 'نفّذ مزامنة كاملة لاتصالات Google/Outlook ثم لخّص باختصار ما الذي تم تحديثه في التقويم.' },
            { role: 'خدمة العملاء', label: 'إنشاء حدث', prompt: 'أنشئ حدثًا في التقويم غدًا الساعة 10:00 باسم "مكالمة متابعة مع عميل" لمدة ساعة واحدة مع تذكير قبل 15 دقيقة. اعرض تأكيدًا قبل التنفيذ.' },
            { role: 'المبيعات', label: 'عملاء محتملون واعدون', prompt: 'اعثر على رسائل من الأسبوع الماضي تشير إلى عميل محتمل أو طلب عرض سعر، ورتّبها حسب احتمالية الإغلاق.' },
            { role: 'المبيعات', label: 'رسالة متابعة', prompt: 'أعِدّ رسالة قصيرة إلى عميل تطلب التفاصيل الناقصة لعرض السعر. اعرض لي المستلم والموضوع والمحتوى قبل الموافقة على الإرسال.' },
            { role: 'المبيعات', label: 'حسابات البريد', prompt: 'اعرض لي جميع حسابات البريد الإلكتروني المتصلة بالمستخدم الخاص بي، بما في ذلك اسم العرض والبروتوكول.' },
            { role: 'المبيعات', label: 'اتصالات السحابة', prompt: 'اعرض لي اتصالات Google Drive وDropbox النشطة لديّ وقواعد الأرشفة المُعدّة لها.' },
            { role: 'المبيعات', label: 'ذاكرة شخصية', prompt: 'تذكّر أنني أفضّل تلقّي الملخصات بالعربية، مع بنود الإجراءات في أعلى القائمة وبدون تفاصيل غير ضرورية.' },
        ],
    },

    // ==================== PWA INSTALL BANNER ====================
    pwa: {
        installSubtitle: 'ثبّت التطبيق لتجربة أسرع',
        iosHowTo: 'للتثبيت على iPhone:',
        iosStep1: '1. اضغط على زر المشاركة',
        iosStep2: '2. مرّر لأسفل واختر "إضافة إلى الشاشة الرئيسية"',
        iosStep3: '3. اضغط "إضافة" في الزاوية العلوية',
        gotIt: 'فهمت',
        installInstructions: 'تعليمات التثبيت',
        installApp: 'تثبيت التطبيق',
        notNow: 'ليس الآن',
        noStoreNeeded: 'دون الحاجة للتنزيل من المتجر • وصول سريع من الشاشة الرئيسية',
    },

    // ==================== PAYMENT RESULT ====================
    payment: {
        successTitle: 'اكتمل الدفع | Email Lion',
        failureTitle: 'فشل الدفع | Email Lion',
        successHeading: 'تم إكمال الدفع بنجاح!',
        successBody: 'شكرًا لشرائك. سيتم تفعيل الباقة قريبًا وستتلقى رسالة بريد إلكتروني تحتوي على تفاصيل التفعيل.',
        loginBtn: 'تسجيل الدخول',
        homeBtn: 'الصفحة الرئيسية',
        failureHeading: 'لم يكتمل الدفع',
        failureBody: 'حدث خطأ أثناء معالجة الدفع. يمكنك المحاولة مرة أخرى أو التواصل مع الدعم.',
        tryAgain: 'حاول مرة أخرى',
    },
};

export default ar;
